(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div id=\"loader\" [hidden]=\"!isLoading\"></div>\r\n<div [hidden]=\"isLoading\" class=\"router-output\">\r\n  <app-privacy-banner></app-privacy-banner>\r\n  <div class=\"container main-container\">\r\n    <div class=\"row\" [hidden]=\"hideCompanyLogo\">\r\n      <div class=\"col-md-12 text-center\">\r\n        <a [routerLink]=\"['/']\">\r\n          <img class=\"brand-logo\" src=\"../../assets/images/company_logo.png\" alt=\"schwarzes-brett-logo\" />\r\n        </a>\r\n      </div>\r\n    </div>\r\n    <router-outlet></router-outlet>\r\n  </div>\r\n  <app-footer></app-footer>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/appointment-list-tile/appointment-list-tile.component.html":
/*!*****************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/appointment-list-tile/appointment-list-tile.component.html ***!
  \*****************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"appointment-list-tile\">\r\n  <div #thisdiv *ngFor=\"let model of models; index as i\" class=\"row topic-list-item\" [class.highlighted]=\"model.highlighted\">\r\n      <div class=\"col-2\">\r\n          <img src=\"{{model.typeIconUrl}}\" alt=\"\" class=\"img-fluid\"><br>\r\n        </div>\r\n      <div class=\"col-7\">\r\n        <p class=\"brand-color tile-title\">\r\n          <a [routerLink]=\"\" class=\"list-item-link\" (click)=\"moreClicked('appointment-' + (i + 1))\">{{model.title}}</a>\r\n        </p>\r\n        <p class=\"topic-subtitle\">{{model.subTitle}}</p>\r\n      </div>\r\n      <div class=\"col-3\">\r\n        <div class=\"current-date float-right\">{{model.dateLabel}}</div><br>\r\n        <div class=\"text-right\">\r\n          <a [routerLink]=\"\" class=\"list-item-link\" (click)=\"moreClicked('appointment-' + (i + 1))\">mehr</a>\r\n        </div>\r\n      </div>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/appointment-tile/appointment-tile.component.html":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/appointment-tile/appointment-tile.component.html ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"appointment-tile\">\r\n  <div class=\"row appointment-header-row\">\r\n    <div class=\"col-2\">\r\n      <img *ngIf=\"model.typeIconUrl\" src=\"{{model.typeIconUrl}}\" alt=\"icon\" class=\"img-fluid\">\r\n    </div>\r\n    <div class=\"col-7\">\r\n      <p class=\"brand-color tile-title\">{{model.title}}</p>\r\n      <p class=\"tile-subtitle\">{{model.subTitle}}</p>\r\n    </div>\r\n    <div class=\"col-3\">\r\n      <p class=\"current-date float-right\">{{model.dateLabel}}</p>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-12 wysiwyg-content\" [innerHTML]=\"model.content\"></div>\r\n    <div class=\"col-12\" *ngIf=\"model.attachment\">\r\n      <a href=\"\" (click)=\"downloadAttachment()\">{{model.attachment.name}}</a>\r\n    </div>\r\n  </div>\r\n  <div *ngIf=\"model.backButton\" class=\"row\">\r\n    <div class=\"col-12 text-right\">\r\n      <label class=\"list-item-link\" (click)=\"backClicked()\">zurück</label>\r\n    </div>\r\n  </div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/backbutton/backbutton.component.html":
/*!*******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/backbutton/backbutton.component.html ***!
  \*******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<a [routerLink]=\"['']\">\r\n  <div class=\"back-button\">\r\n    <i class=\"left\"></i>\r\n  </div>\r\n</a>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/canvas-clock/canvas-clock.component.html":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/canvas-clock/canvas-clock.component.html ***!
  \***********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<canvas #canvasClock></canvas>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/carousel/carousel.component.html":
/*!***************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/carousel/carousel.component.html ***!
  \***************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- Template taken from the original ng-bootstrap/carousel on Github\r\n  Only changes are line 7, 9 -->\r\n<ol class=\"carousel-indicators\" *ngIf=\"showNavigationIndicators\">\r\n  <li *ngFor=\"let slide of slides\" [id]=\"slide.id\" [class.active]=\"slide.id === activeId\"\r\n    (click)=\"select(slide.id, NgbSlideEventSource.INDICATOR)\"></li>\r\n</ol>\r\n<div class=\"carousel-inner\" (touchstart)=\"swipe($event, 'start')\" (touchend)=\"swipe($event, 'end')\" >\r\n  <div *ngFor=\"let slide of slides\" class=\"carousel-item\" [class.active]=\"slide.id === activeId\"\r\n    [@slide]=\"getSlideState(slide.id) | async\">\r\n    <ng-template [ngTemplateOutlet]=\"slide.tplRef\"></ng-template>\r\n  </div>\r\n</div>\r\n<a class=\"carousel-control-prev\" role=\"button\" (click)=\"prev(NgbSlideEventSource.ARROW_LEFT)\"\r\n  *ngIf=\"showNavigationArrows\">\r\n  <span class=\"carousel-control-prev-icon\" aria-hidden=\"true\"></span>\r\n  <span class=\"sr-only\" i18n=\"@@ngb.carousel.previous\">Previous</span>\r\n</a>\r\n<a class=\"carousel-control-next\" role=\"button\" (click)=\"next(NgbSlideEventSource.ARROW_RIGHT)\"\r\n  *ngIf=\"showNavigationArrows\">\r\n  <span class=\"carousel-control-next-icon\" aria-hidden=\"true\"></span>\r\n  <span class=\"sr-only\" i18n=\"@@ngb.carousel.next\">Next</span>\r\n</a>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/contact-tile/contact-tile.component.html":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/contact-tile/contact-tile.component.html ***!
  \***********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"contact-tile\">\r\n  <div class=\"row\">\r\n    <div class=\"col-8\">\r\n      <p class=\"brand-color tile-title\">{{model.role}}</p>\r\n      <p class=\"tile-subtitle\">{{model.company}}</p>\r\n    </div>\r\n    <div class=\"col-4 float-right\">\r\n      <img *ngIf=\"model.logoBase64\" src=\"{{model.logoBase64}}\" alt=\"icon\" class=\"float-right img-fluid contact-logo\">\r\n    </div>\r\n  </div>\r\n  <!-- start employee card -->\r\n  <div class=\"row contact-card\">\r\n    <div class=\"col-8\">\r\n      <div class=\"header\">\r\n        <div class=\"fullname\"><strong>{{model.name}}</strong></div>\r\n        <div *ngIf=\"model.position\">{{model.position}}</div>\r\n      </div>\r\n      <div *ngIf=\"!isNullOrUndefined(model.phoneNumber)\">T&nbsp;&nbsp;<a\r\n          href=\"tel:{{model.phoneNumber}}\">{{model.phoneNumber}}</a></div>\r\n      <div *ngIf=\"!isNullOrUndefined(model.mobilePhone)\">M&nbsp;&nbsp;<a\r\n          href=\"tel:{{model.mobilePhone}}\">{{model.mobilePhone}}</a></div>\r\n      <div *ngIf=\"!isNullOrUndefined(model.email)\">E&nbsp;&nbsp;<a href=\"mailto:{{model.email}}\">{{model.email}}</a>\r\n      </div>\r\n      <div *ngIf=\"!isNullOrUndefined(model.url)\">L&nbsp;&nbsp;<a href=\"{{model.url}}\"\r\n          target=\"_blank\">{{isNullOrUndefined(model.urlLabel) ? model.url : model.urlLabel}}</a></div>\r\n    </div>\r\n    <div class=\"col-4\">\r\n      <img *ngIf=\"model.photoBase64\" src=\"{{model.photoBase64}}\" alt=\"{{model.name}}\"\r\n        class=\"float-right img-fluid contact-photo\">\r\n    </div>\r\n    <div *ngIf=\"model.additionalInfo\" class=\"col-12 info-text\">\r\n      {{model.additionalInfo}}\r\n    </div>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/day-names-motto-tile/day-names-motto-tile.component.html":
/*!***************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/day-names-motto-tile/day-names-motto-tile.component.html ***!
  \***************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div id=\"nameMottoTile\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <br />\r\n      <h6 class=\"brand-color\">Namenstage:</h6>\r\n      <p>{{names}}</p>\r\n    </div>\r\n    <div class=\"col-md-12\">\r\n      <br />\r\n      <h6 class=\"brand-color\">Motto der Woche:</h6>\r\n      <p>{{slogan}}</p>\r\n    </div>\r\n  </div>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/day-overview-tile/day-overview-tile.component.html":
/*!*********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/day-overview-tile/day-overview-tile.component.html ***!
  \*********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\r\n  <div class=\"col-6\">\r\n    <div class=\"weather-current-day\">\r\n      <i class=\"wi {{model.iconClass}}\"></i>\r\n      <h2>{{model.temp.day}}°</h2>\r\n      <p>{{model.weather.description}}</p>\r\n    </div>\r\n    <div class=\"daily-forcast\">\r\n      <div class=\"row\">\r\n        <!--<div class=\"col-4\">\r\n          <h5>{{model.temp.morn}}°</h5>\r\n          <p>Vormittag</p>\r\n        </div>\r\n        <div class=\"col-4\">\r\n          <h5>{{model.temp.eve}}°</h5>\r\n          <p>Nachmittag</p>\r\n        </div>\r\n        <div class=\"col-4\">\r\n          <h5>{{model.temp.night}}°</h5>\r\n          <p>Nacht</p>\r\n        </div>-->\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-6\">\r\n    <div class=\"float-right\">\r\n      <app-canvas-clock></app-canvas-clock>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-12\">\r\n    <div class=\"daily-forcast-mobile\">\r\n      <div class=\"row\">\r\n        <!--<div class=\"col-4\">\r\n          <h5>{{model.temp.morn}}°</h5>\r\n          <p>Vormittag</p>\r\n        </div>\r\n        <div class=\"col-4\">\r\n          <h5>{{model.temp.eve}}°</h5>\r\n          <p>Nachmittag</p>\r\n        </div>\r\n        <div class=\"col-4\">\r\n          <h5>{{model.temp.night}}°</h5>\r\n          <p>Nacht</p>\r\n        </div>-->\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/footer/footer.component.html":
/*!***********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/footer/footer.component.html ***!
  \***********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<footer class=\"footer mt-auto py-3\">\r\n  <div class=\"container\">\r\n    <div class=\"footer-row text-center\">\r\n      <ul class=\"footer-navigation\">\r\n        <li [hidden]=\"isSingleBuildingMode\">\r\n          <a [routerLink]=\"\" (click)=\"searchClicked()\">Suche</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"['/privacy-policy']\">Datenschutzerkl&auml;rung</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"['/imprint']\">Impressum & Kontakt</a>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n</footer>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/house-number-plaque/house-number-plaque.component.html":
/*!*************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/house-number-plaque/house-number-plaque.component.html ***!
  \*************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"text-center\">\r\n    <div class=\"houseNumberPlaque\">\r\n        <div>\r\n            <h3>{{model.city}}</h3>\r\n            <h1>{{model.label}}</h1>\r\n        </div>\r\n    </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/kiosk-modal/kiosk-modal.component.html":
/*!*********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/kiosk-modal/kiosk-modal.component.html ***!
  \*********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"modal-header\">\n    <!-- <h4 class=\"modal-title\">Modal title</h4> -->\n    <button type=\"button\" class=\"btn close btn-close\" aria-label=\"Close\" (click)=\"activeModal.dismiss('Cross click')\">&times;</button>\n</div>\n<div class=\"modal-body\">\n    <p class=\"modal-heading\">Weitersurfen am eigenen Smartphone</p>\n    <p class=\"modal-message\"> Fahren Sie zum Öffnen externer Inhalte bitte mit Ihrem eigenen Smartphone fort!</p>\n    <p class=\"links-to\">Verlinkt auf: <span class=\"link\">{{url}}</span></p>\n    <div class=\"phone-container\">\n        <qrcode class=\"qr-code\" [qrdata]=\"url\" [margin]=\"1\" [width]=\"300\" [errorCorrectionLevel]=\"'Q'\" [elementType]=\"'img'\"></qrcode>\n        <div class=\"scan-me\">Scan Me</div>\n    </div>\n</div>\n<!-- <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-light\" (click)=\"activeModal.close('Close click')\">Close</button>\n</div> -->");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/links-tile/links-tile.component.html":
/*!*******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/links-tile/links-tile.component.html ***!
  \*******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<app-tile headline=\"Links\">\r\n  <div class=\"row\" style=\"height: 132px;\" *ngFor=\"let linkrow of links\">\r\n    <div class=\"col-4 col-xs-4 col-sm-4 col-md-4 col-lg-4 text-center link-tile\" *ngFor=\"let link of linkrow; index as i;\">\r\n      <a *ngIf=\"link.url && link.url.length > 0 && link.iconPath && link.iconPath.length > 0\" href=\"{{link.url}}\" target=\"_blank\">\r\n        <img class=\"img-fluid\" src=\"{{link.iconPath}}\" alt=\"{{link.title}}\">\r\n      </a>\r\n      <br>\r\n      <a *ngIf=\"link.url && link.url.length > 0\" href=\"{{link.url}}\" target=\"_blank\">{{link.title}}</a>\r\n    </div>\r\n  </div>\r\n</app-tile>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/no-data/no-data.component.html":
/*!*************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/no-data/no-data.component.html ***!
  \*************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"no-data\">\r\n    <div class=\"text\">\r\n      Keine Daten vorhanden\r\n    </div>\r\n  </div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/privacy-banner/privacy-banner.component.html":
/*!***************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/privacy-banner/privacy-banner.component.html ***!
  \***************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div [hidden]=\"!isEnabled\" class=\"alert alert-dark alert-dismissible alert-privacy fade show\" role=\"alert\">\r\n    Wir verwenden Cookies, um unsere Webseite für Sie möglichst benutzerfreundlich zu gestalten. Wenn Sie fortfahren,\r\n    nehmen wir an, dass Sie mit der Verwendung von Cookies auf dieser Webseite einverstanden sind. Weitere Informationen\r\n    finden Sie in unserer <span class=\"privacy-policy-link\" (click)=\"privacyPolicyClicked()\">Datenschutzerkl&auml;rung</span>.\r\n    <button id=\"close-alert\" type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\" (click)=\"closeClicked()\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n  </div>\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/privacy-policy/privacy-policy.component.html":
/*!***************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/privacy-policy/privacy-policy.component.html ***!
  \***************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\r\n  <div class=\"col-12 text-center\">\r\n    <h2>Datenschutzerkl&auml;rung</h2>\r\n  </div>\r\n  <br><br><br>\r\n  <p>\r\n    Lieber Nutzer,\r\n    wir nehmen den Schutz Ihrer personenbezogener Daten sehr ernst und möchte Sie daher darüber informieren, wie mit\r\n    Ihren persönlichen Daten umgegangen wird, die Sie uns im Zuge der Nutzung unseres Angebotes übermitteln.\r\n  </p>\r\n  <br>\r\n  <br>\r\n  <b>Keine Datenspeicherung im Informationsteil des Angebots </b>\r\n  <p>\r\n    Wenn Sie nur den Informationsteil unseres Internet-Angebots nutzen, benötigen und speichern wir keine persönlichen\r\n    Daten.\r\n  </p>\r\n  <b>Hinweis auf Datenschutzerklärung</b>\r\n  <p>Vor jeder Speicherung von persönlichen Daten, werden wir Sie auf diese Datenschutzerklärung hinweisen. Die\r\n    Speicherung nehmen wir nur vor, wenn Sie dieser Datenschutzerklärung zugestimmt haben. Wir verarbeiten Ihre Daten\r\n    mit äußerster Sorgfalt und nutzen sie ausschließlich für die Vertragserfüllung und Ihre geschäftliche Information\r\n    durch uns und unsere Geschäftspartner, an die wir Ihre Daten weiter geben.</p>\r\n\r\n  <b>Speicherung von persönlichen und sonstigen Daten</b>\r\n  <p>Die zur Auftragserteilung notwendigerweise auszufüllenden Felder sind mit einem * gekennzeichnet. Es werden nur\r\n    jene personenbezogenen Daten als verpflichtend markiert, die unerlässlich für die Auftragserteilung sind. Die\r\n    Eingabe weiterer Daten erfolgt auf freiwilliger Basis und wird für sie in den häufigsten Fällen vorteilhaft sein.\r\n  </p>\r\n\r\n  <b>Benachrichtigungen</b>\r\n  <p>Die von Ihnen bekanntgegebene E-Mail-Adresse wird zum Zweck des Versandes der abonnierten Benachrichtigungen zu\r\n    Objekt-Neuigkeiten gespeichert. Sie haben das Recht Ihre Einwilligung jederzeit kostenlos zu widerrufen. Um Ihren\r\n    Widerruf zu erklären, klicken Sie auf den Abmeldelink im E-Mail.</p>\r\n\r\n  <b>Cookies</b>\r\n  <p>Teilweise werden Cookies benutzt, um Ihnen die Nutzung unseres Angebotes zu erleichtern. Cookies sind kleine\r\n    Informationsdateien, die von Ihrem Internet-Browser auf die Festplatte Ihres Computers gespeichert werden. Unsere\r\n    Cookies enthalten keine personenbezogenen Daten. Die meisten Internet-Browser akzeptieren Cookies automatisch,\r\n    können jedoch so eingestellt werden, dass sie Cookies ablehnen. Wenn Sie Probleme bei der Nutzung des Angebots\r\n    haben, sollten Sie zunächst die Sicherheitseinstellungen Ihres Browsers bezüglich der Behandlung von Cookies\r\n    überprüfen und ihn so einstellen, dass er Cookies akzeptiert.</p>\r\n\r\n  <b>Wiederruf</b>\r\n  <p>\r\n    Sie können eine einmal erteilte Einwilligung zur Nutzung Ihrer Daten jederzeit schriftlich oder elektronisch\r\n    widerrufen.\r\n\r\n    Im Falle Ihres Widerrufs der Speicherung und der Verarbeitung Ihrer Daten können wir bestimmte Dienste wie z.B. die\r\n    Zustellung des Newsletters nicht mehr erbringen.</p>\r\n\r\n  <b>Nutzungsauswertung mit Hilfe von Google Analytics</b>\r\n  <p>Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc. (“Google”). Google Analytics\r\n    verwendet sog. “Cookies”, Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung\r\n    der Website durch Sie ermöglichen. Die durch den Cookie erzeugten Informationen über Ihre Benutzung dieser Website\r\n    werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert. Im Falle der Aktivierung\r\n    der IP-Anonymisierung auf dieser Webseite, wird Ihre IP-Adresse von Google jedoch innerhalb von Mitgliedstaaten der\r\n    Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum zuvor\r\n    gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA übertragen und dort\r\n    gekürzt. Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung der\r\n    Website auszuwerten, um Reports über die Websiteaktivitäten zusammenzustellen und um weitere mit der Websitenutzung\r\n    und der Internetnutzung verbundene Dienstleistungen gegenüber dem Websitebetreiber zu erbringen. Die im Rahmen von\r\n    Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt.\r\n    Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern, wir\r\n    weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website\r\n    vollumfänglich werden nutzen können. Sie können darüber hinaus die Erfassung der durch das Cookie erzeugten und auf\r\n    Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten\r\n    durch Google, wie nachfolgend beschrieben, verhindern.</p>\r\n\r\n  <b>Widerspruchsmöglichkeit</b>\r\n  <p>Der Datenerhebung und -speicherung durch Google Analytics kann jederzeit mit Wirkung für die Zukunft widersprochen\r\n    werden. Sie haben dazu die Möglichkeit, ein von Google herausgegebenes Browser-Plugin zu installieren. Dieses steht\r\n    für verschiedene Browser-Versionen zur Verfügung und kann unter <a\r\n      href=\"http://tools.google.com/dlpage/gaoptout?hl=de\"\r\n      target=\"_blank\">http://tools.google.com/dlpage/gaoptout?hl=de</a>\r\n    heruntergeladen werden.</p>\r\n\r\n  <b>Benachrichtigungen</b>\r\n  <p>Die von Ihnen bekanntgegebene E-Mail-Adresse wird zum Zweck des Versandes der abonnierten Benachrichtigungen zu\r\n    Objekt-Neuigkeiten gespeichert. Sie haben das Recht Ihre Einwilligung jederzeit kostenlos zu widerrufen. Um Ihren\r\n    Widerruf zu erklären, klicken Sie auf den Abmeldelink im E-Mail.</p>\r\n</div>\r\n<app-backbutton></app-backbutton>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/qrcode-tile/qrcode-tile.component.html":
/*!*********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/qrcode-tile/qrcode-tile.component.html ***!
  \*********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<app-tile headline=\"Weitersurfen am Smartphone\">\n  <p>Scannen Sie den QR-Code, um das Infoboard ToGo auf Ihrem Smartphone zu öffnen!</p>\n  <qrcode class=\"qr-code\" [qrdata]=\"url\" [margin]=\"1\" [errorCorrectionLevel]=\"'Q'\" [elementType]=\"'img'\"></qrcode>\n  <a  [href]=\"url\">{{url}}</a>\n</app-tile>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/scroll-to-top/scroll-to-top.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/scroll-to-top/scroll-to-top.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"scroll-to-top\" [ngClass]=\"{'show-scrollTop': windowScrolled}\" (click)=\"scrollToTop()\">\r\n      <i class=\"up\"></i>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/subscribe-tile/subscribe-tile.component.html":
/*!***************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/subscribe-tile/subscribe-tile.component.html ***!
  \***************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<app-tile headline=\"Benachrichtigungen abonnieren\">\r\n  <form (ngSubmit)=\"onSubmit(subscribeForm)\" #subscribeForm=\"ngForm\" ngControl=\"myForm\" [hidden]=\"complete || error\">\r\n    <div class=\"form-group\">\r\n      <p>Nutzen Sie die Möglichkeit, sich für Aktuelles und Termine per Mail benachrichtigen zu lassen!</p>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <div class=\"form-row\">\r\n        <input class=\"form-control col-8 rounded-0 subscribe-email\"\r\n          [ngClass]=\"{'has-error': subscribeForm.submitted && email.invalid }\" type=\"text\" name=\"email\"\r\n          placeholder=\"E-Mail-Adresse eingeben\" [(ngModel)]=\"model.email\" email required #email=\"ngModel\" />\r\n        <button type=\"submit\" class=\"form-control rounded-0 col-4 button-send\">\r\n          <span>Abonnieren<span class=\"span-arrow hide-sm\"> &nbsp;&rarr;</span></span>\r\n        </button>\r\n        <div [hidden]=\"false\" class=\"error-msg\">\r\n          <p *ngIf=\"subscribeForm.submitted && email.errors?.required\">* Geben Sie eine E-Mail-Adresse ein.</p>\r\n          <p *ngIf=\"subscribeForm.submitted && email.errors?.email\">* Die E-Mail-Adresse ist ungültig.</p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"form-group\">\r\n      <div class=\"form-row\">\r\n        <label><input type=\"checkbox\" [(ngModel)]=\"model.acceptPrivacyPolicy\" name=\"acceptPrivacyPolicy\" required\r\n            #privacyPolicy=\"ngModel\" /> Ich habe die <a href=\"./privacy-policy\">Datenschutzerklärung</a> gelesen.\r\n        </label>\r\n        <p [hidden]=\"!subscribeForm.submitted || privacyPolicy.valid\" class=\"error-msg\">\r\n          * Die Datenschutzerklärung muss akzeptiert werden.\r\n        </p>\r\n      </div>\r\n    </div>\r\n  </form>\r\n  <div [hidden]=\"!error\" class=\"alert alert-danger\">\r\n    <span [hidden]=\"errorMessage\">Bei der Anmeldung ist leider etwas schief gelaufen. Bitte probieren Sie es später wieder.</span>\r\n    <span [hidden]=\"!errorMessage\" [textContent]=\"errorMessage\"></span>\r\n  </div>\r\n  <div [hidden]=\"!complete\">\r\n    Um die Anmeldung für Benachrichtigungen abzuschließen, klicken Sie bitte auf den Link, den wir per E-Mail geschickt haben.\r\n  </div>\r\n</app-tile>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/tile/tile.component.html":
/*!*******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/tile/tile.component.html ***!
  \*******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"tile\">\r\n  <h5 *ngIf=\"!slideInfo\">{{headline}}</h5>\r\n  <div *ngIf=\"slideInfo\" class=\"clearfix\">\r\n      <h5 class=\"float-left\">{{headline}}</h5>\r\n      <h5 class=\"float-right text-right slideinfo\">{{slideInfo.currentSlideNumber}} / {{slideInfo.totalSlideCount}}</h5>\r\n  </div>\r\n  <div class=\"inner\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/topic-list-tile/topic-list-tile.component.html":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/topic-list-tile/topic-list-tile.component.html ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"topic-list-tile\">\r\n  <div #thisdiv *ngFor=\"let model of models; index as i\" class=\"row topic-list-item\">\r\n    <div class=\"col-2\">\r\n      <img src=\"{{model.typeIconUrl}}\" alt=\"\" class=\"img-fluid\"><br>\r\n    </div>\r\n    <div class=\"col-7\">\r\n      <p class=\"brand-color tile-title\">\r\n        <a [routerLink]=\"\" class=\"list-item-link\" (click)=\"moreClicked('announcement-' + (i + 1))\">{{model.title}}</a>\r\n      </p>\r\n      <p class=\"topic-subtitle\">{{model.subtitle}}</p>\r\n    </div>\r\n    <div class=\"col-3\">\r\n      <div class=\"current-date float-right\">{{model.publishedOnLabel}}</div><br>\r\n      <div class=\"text-right\">\r\n        <a [routerLink]=\"\" class=\"list-item-link\" (click)=\"moreClicked('announcement-' + (i + 1))\">mehr</a>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/topic-tile/topic-tile.component.html":
/*!*******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/topic-tile/topic-tile.component.html ***!
  \*******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"topic-tile\">\r\n  <div class=\"row topic-header-row\">\r\n    <div class=\"col-2\">\r\n      <img *ngIf=\"model.typeIconUrl\" src=\"{{model.typeIconUrl}}\" alt=\"icon\" class=\"img-fluid\">\r\n    </div>\r\n    <div class=\"col-7\">\r\n      <p class=\"brand-color tile-title\">{{model.title}}</p>\r\n      <p class=\"tile-subtitle\">{{model.subtitle}}</p>\r\n    </div>\r\n    <div class=\"col-3\">\r\n      <p class=\"current-date float-right\">{{model.publishedOnLabel}}</p>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\" *ngIf=\"model.imageBase64\">\r\n    <div class=\"col-9 wysiwyg-content\" [innerHTML]=\"model.content\"></div>\r\n    <div class=\"col-3\"><img class=\"img-fluid\" src=\"{{model.imageBase64}}\" /></div>\r\n    <div class=\"col-12\" *ngIf=\"model.attachment\">\r\n      <a href=\"\" (click)=\"downloadAttachment()\">{{model.attachment.name}}</a>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\" *ngIf=\"!model.imageBase64\">\r\n      <div class=\"col-12 wysiwyg-content\" [innerHTML]=\"model.content\"></div>\r\n      <div class=\"col-12\" *ngIf=\"model.attachment\">\r\n          <a href=\"\" (click)=\"downloadAttachment()\">{{model.attachment.name}}</a>\r\n      </div>\r\n  </div>\r\n\r\n  <div *ngIf=\"model.backButton\" class=\"row\">\r\n      <div class=\"col-12 text-right\">\r\n        <label class=\"list-item-link\" (click)=\"backClicked()\">zurück</label>\r\n      </div>\r\n  </div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/views/building-search/building-search.component.html":
/*!************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/views/building-search/building-search.component.html ***!
  \************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"container\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12 text-center\">\r\n      <div class=\"page-header\">\r\n        <div class=\"headline\">\r\n          <img src=\"../../../assets//images/schwarzesbrett_togo_logo.jpg\" alt=\"Das Schwarze Brett ToGo\"\r\n            class=\"headline-logo\">\r\n        </div>\r\n        <div class=\"divider\"></div>\r\n        <div class=\"subline\">\r\n          Kontakte, Aktuelles und mehr\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-12\">\r\n      <p>Bitte geben Sie den Straßennamen des gewünschten Objekts ein</p>\r\n      <input class=\"buildingSearch\" (keyup)=\"onKeyUp($event)\" [(ngModel)]=\"value\" placeholder=\"Suche...\" autofocus>\r\n    </div>\r\n    <div class=\"col-12\">\r\n      <ul class=\"buildingList\">\r\n        <li *ngFor=\"let building of buildings; index as i;\">\r\n          <a href=\"\" (click)=\"boardClick(building)\">{{building.label}}</a>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/views/home/home.component.html":
/*!**************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/views/home/home.component.html ***!
  \**************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\r\n  <div class=\"col-md-12 text-center\">\r\n    <div class=\"page-header\">\r\n      <div class=\"headline\">\r\n        <img src=\"../../../assets//images/schwarzesbrett_togo_logo.jpg\" alt=\"Das Schwarze Brett ToGo\"\r\n          class=\"headline-logo\">\r\n      </div>\r\n      <div class=\"divider\"></div>\r\n      <div class=\"subline\">\r\n        Schönen {{weekday}}\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"row\">\r\n  <div class=\"col-md-12\">\r\n    <app-house-number-plaque *ngIf=\"idBuilding\" [idBuilding]=\"idBuilding\"></app-house-number-plaque>\r\n  </div>\r\n</div>\r\n<div class=\"row\">\r\n  <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n    <app-tile headline=\"Ihr Tag\" [slideInfo]=\"yourDaySlideInfo\">\r\n      <div class=\"row my-day-header\">\r\n        <div class=\"col-3\">\r\n          <p class=\"brand-color tile-title\">aktuell</p>\r\n        </div>\r\n        <div class=\"col-9\">\r\n          <p class=\"current-date float-right\">{{currentDay}}</p>\r\n        </div>\r\n      </div>\r\n      <app-carousel id=\"yourDay\" class=\"carousel\" (slide)=\"afterSlide($event, yourDaySlideInfo)\">\r\n        <ng-template ngbSlide [id]=\"'yourDay-0'\">\r\n          <app-day-overview-tile *ngIf=\"idBuilding\" [idBuilding]=\"idBuilding\"></app-day-overview-tile>\r\n        </ng-template>\r\n        <ng-template ngbSlide [id]=\"'yourDay-1'\">\r\n          <app-day-names-motto-tile></app-day-names-motto-tile>\r\n        </ng-template>\r\n      </app-carousel>\r\n    </app-tile>\r\n  </div>\r\n  <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n    <app-tile headline=\"Kontakte\" [slideInfo]=\"contactsSlideInfo\">\r\n      <app-carousel *ngIf=\"contacts\" [interval]=\"6000\" class=\"carousel\" (slide)=\"afterSlide($event, contactsSlideInfo)\">\r\n        <ng-template ngbSlide [id]=\"'contact-' + i\" *ngFor=\"let contact of contacts; let i = index\">\r\n          <app-contact-tile [model]=\"contact\"></app-contact-tile>\r\n        </ng-template>\r\n      </app-carousel>\r\n    </app-tile>\r\n  </div>\r\n  <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n    <app-tile headline=\"Notdienste\" [slideInfo]=\"emergencyContactsSlideInfo\">\r\n      <app-carousel [interval]=\"12000\" class=\"carousel\" (slide)=\"afterSlide($event, emergencyContactsSlideInfo)\">\r\n        <ng-template ngbSlide [id]=\"'emergencyContact-0'\">\r\n          <div class=\"contact-tile\">\r\n            <div class=\"row\">\r\n              <div class=\"col-8\">\r\n                <p class=\"brand-color tile-title\">NOTRUF</p>\r\n                <p class=\"tile-subtitle\">Emergency Call</p>\r\n              </div>\r\n              <div class=\"col-4 float-right\">\r\n                <img src=\"../../assets/images/emergencyicons/call.png\" alt=\"info icon\"\r\n                  class=\"float-right img-fluid contact-logo\">\r\n              </div>\r\n              <div class=\"col-12 emergency-row\">\r\n                <a style=\"color: #d11621\" href=\"tel:122\">\r\n                  <img src=\"../../assets/images/emergencyicons/fire.png\" alt=\"fire\">\r\n                  Feuerwehr 122\r\n                </a>\r\n              </div>\r\n              <div class=\"col-12 emergency-row\">\r\n                <a style=\"color: #031653\" href=\"tel:133\">\r\n                  <img src=\"../../assets/images/emergencyicons/police.png\" alt=\"police\">\r\n                  Polizei 133\r\n                </a>\r\n              </div>\r\n              <div class=\"col-12 emergency-row\">\r\n                <a style=\"color: #ff0000\" href=\"tel:144\">\r\n                  <img src=\"../../assets/images/emergencyicons/rescue.png\" alt=\"rescue\">\r\n                  Rettung 144</a>\r\n              </div>\r\n              <div class=\"col-12 emergency-row\">\r\n                <a style=\"color: #e4d618\" href=\"tel:128\">\r\n                  <img src=\"../../assets/images/emergencyicons/gas.png\" alt=\"gas\">\r\n                  Gas-Notruf 128\r\n                </a>\r\n              </div>\r\n              <div class=\"col-12 emergency-row\">\r\n                <a style=\"color: #3937b3\" href=\"tel:112\">\r\n                  <img src=\"../../assets/images/emergencyicons/euro.png\" alt=\"euro\">\r\n                  Euronotruf 112</a>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n        <ng-template ngbSlide [id]=\"'emergencyContact-' + (i+1)\"\r\n          *ngFor=\"let emergencyContact of emergencyContacts; let i = index\">\r\n          <app-contact-tile [model]=\"emergencyContact\"></app-contact-tile>\r\n        </ng-template>\r\n      </app-carousel>\r\n    </app-tile>\r\n  </div>\r\n\r\n  <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n    <app-tile headline=\"Aktuelles\" [slideInfo]=\"announcementsSlideInfo\">\r\n      <app-carousel #announcementCarousel [interval]=\"0\" class=\"carousel\"\r\n        (slide)=\"afterSlide($event, announcementsSlideInfo)\">\r\n        <div *ngIf=\"hasAnnouncement\">\r\n          <ng-template ngbSlide [id]=\"'announcement-0'\">\r\n            <app-topic-tile [model]=\"announcement\"></app-topic-tile>\r\n          </ng-template>\r\n        </div>\r\n        <div *ngIf=\"shouldRenderAnnouncements\">\r\n          <ng-template ngbSlide [id]=\"'announcement-' + 0\">\r\n            <app-topic-list-tile [models]=\"announcements\" (moreClick)=\"carouselSlideTo(announcementCarousel, $event)\">\r\n            </app-topic-list-tile>\r\n          </ng-template>\r\n          <ng-template ngbSlide [id]=\"'announcement-' + (i + 1)\"\r\n            *ngFor=\"let announcement of announcements; let i = index\">\r\n            <app-topic-tile [model]=\"announcement\" (backClick)=\"carouselSlideToFirst(announcementCarousel)\">\r\n            </app-topic-tile>\r\n          </ng-template>\r\n        </div>\r\n        <div *ngIf=\"hasAnnouncements === false\">\r\n          <ng-template ngbSlide [id]=\"'announcement-0'\">\r\n            <app-no-data></app-no-data>\r\n          </ng-template>\r\n        </div>\r\n      </app-carousel>\r\n    </app-tile>\r\n  </div>\r\n\r\n  <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n    <app-tile headline=\"Termine\" [slideInfo]=\"appointmentsSlideInfo\">\r\n      <app-carousel #appointmentCarousel [interval]=\"0\" class=\"carousel\" \r\n      (slide)=\"afterSlide($event, appointmentsSlideInfo)\">\r\n        <div *ngIf=\"hasAppointment\">\r\n          <ng-template ngbSlide [id]=\"'appointment-0'\">\r\n            <app-appointment-tile [model]=\"appointment\"></app-appointment-tile>\r\n          </ng-template>\r\n        </div>\r\n        <div *ngIf=\"shouldRenderAppointments\">\r\n          <ng-template ngbSlide [id]=\"'appointment-' + 0\">\r\n            <app-appointment-list-tile [models]=\"appointments\" (moreClick)=\"carouselSlideTo(appointmentCarousel, $event)\">\r\n            </app-appointment-list-tile>\r\n          </ng-template>\r\n          <ng-template ngbSlide [id]=\"'appointment-' + (i + 1)\" \r\n            *ngFor=\"let appointment of appointments; let i = index\">\r\n            <app-appointment-tile [model]=\"appointment\" (backClick)=\"carouselSlideToFirst(appointmentCarousel)\">\r\n            </app-appointment-tile>\r\n          </ng-template>\r\n        </div>\r\n        <div *ngIf=\"hasAppointments === false\">\r\n          <ng-template ngbSlide [id]=\"'appointment-0'\">\r\n            <app-no-data></app-no-data>\r\n          </ng-template>\r\n        </div>\r\n      </app-carousel>\r\n    </app-tile>\r\n  </div>\r\n\r\n  <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n    <app-tile headline=\"Hausordnung\" [slideInfo]=\"rulesSlideInfo\">\r\n      <app-carousel *ngIf=\"rules\" [interval]=\"6000\" class=\"carousel\" (slide)=\"afterSlide($event, rulesSlideInfo)\">\r\n        <ng-template ngbSlide [id]=\"'rule-' + i\" *ngFor=\"let rule of rules; let i = index\">\r\n          <div class=\"house-rules text-center\">\r\n            <img class=\"house-rule-img\" [src]=\"rule\" alt=\"Random first slide\">\r\n          </div>\r\n        </ng-template>\r\n      </app-carousel>\r\n    </app-tile>\r\n  </div>\r\n  <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n    <app-links-tile></app-links-tile>\r\n  </div>\r\n  <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n    <app-subscribe-tile *ngIf=\"idBuilding\" [idBuilding]=\"idBuilding\"></app-subscribe-tile>\r\n  </div>\r\n  <div *ngIf=\"isDemo\" class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n    <div class=\"demo-logos\">\r\n      <div class=\"row\">\r\n        <div class=\"col-12 \">\r\n          <a target=\"_blank\" href=\"https://www.schwarzesbrett.info/das-schwarze-brett/togo/\" rel=\"noopener noreferrer\">\r\n            <img class=\"demo-logo-sb\" src=\"../../assets/images/company_logo.png\" alt=\"Das Schwarze Brett\">\r\n          </a>\r\n        </div>\r\n        <div class=\"col-12\">\r\n          <span class=\"vertical-bottom\">powered by &nbsp;</span>\r\n          <a target=\"_blank\" href=\"https://www.frieden-informatik.at\" rel=\"noopener noreferrer\">\r\n            <img class=\"demo-logo-fi\" src=\"../../assets/images/frieden-informatik_logo.svg\" alt=\"FRIEDEN Informatik\">\r\n          </a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <app-scroll-to-top></app-scroll-to-top>\r\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/views/imprint/imprint.component.html":
/*!********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/views/imprint/imprint.component.html ***!
  \********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row\">\r\n  <div class=\"col-12 text-center\">\r\n    <h2>Impressum</h2>\r\n  </div>\r\n  <p>\r\n    <br>\r\n    <b>Informationseigentümer</b> <br>\r\n    BFM Facility Management GmbH<br>\r\n    Ein Unternehmern der BODNER Gruppe<br>\r\n    Salurnerstrasse 57<br>\r\n    6330 Kufstein<br>\r\n    <a href=\"tel:+435069990\" title=\"+43 5 06999 – 0\">T: +43 5 06999 – 0</a><br>\r\n    <a href=\"mailto:office@bfm-facility.at\"> office@bfm-facility.at</a><br><br>\r\n\r\n    <b>Niederlassung Tirol</b><br>\r\n    BFM Facility Management GmbH<br>\r\n    Kreuzgasse 3<br>\r\n    6330 Kufstein<br><br>\r\n\r\n    <b>Niederlassung Salzburg</b><br>\r\n    BFM Facility Management GmbH<br>\r\n    St. Julienstraße 20<br>\r\n    5020 Salzburg<br><br>\r\n\r\n    <b>Rechtsform: </b>Gesellschaft mit beschränkter Haftung<br>\r\n    <b>Sitz: </b>Kufstein<br>\r\n    <b>UID Nummer: </b>ATU 70306117<br>\r\n    <b>Firmenbuch Nummer: </b> FN 446202f<br><br>\r\n\r\n    <b>Haftung</b><br>\r\n    Sämtliche Inhalte wurden sorgfältig geprüft. Dessen ungeachtet kann keine Garantie für Richtigkeit, Vollständigkeit und\r\n    Aktualität der Angaben übernommen werden.\r\n  </p>\r\n</div>\r\n<app-backbutton></app-backbutton>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/views/kiosk-mode/kiosk-mode.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/views/kiosk-mode/kiosk-mode.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>Kiosk-mode is now enabled!</p>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/views/subscription/subscription.component.html":
/*!******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/views/subscription/subscription.component.html ***!
  \******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p class=\"alert alert-success\" *ngIf=\"success && isSubscribe\">\r\n  Sie haben Benachrichtigungen für {{buildingLabel}} erfolgreich abonniert.\r\n</p>\r\n<p class=\"alert alert-success\" *ngIf=\"success && !isSubscribe\">\r\n  Sie wurden erfolgreich von Benachrichtigungen für {{buildingLabel}} abgemeldet.\r\n</p>\r\n<p class=\"alert alert-danger\" *ngIf=\"!success  && isSubscribe\">\r\n  Bei der Anmeldung ist leider etwas schief gelaufen. Bitte probieren Sie es später wieder.\r\n</p>\r\n<p class=\"alert alert-danger\" *ngIf=\"!success  && !isSubscribe\">\r\n  Bei der Abmeldung ist leider etwas schief gelaufen. Bitte probieren Sie es später wieder.\r\n</p>");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/$$_lazy_route_resource lazy recursive":
/*!**********************************************************!*\
  !*** ./src/$$_lazy_route_resource lazy namespace object ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _views_home_home_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./views/home/home.component */ "./src/app/views/home/home.component.ts");
/* harmony import */ var _views_building_search_building_search_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./views/building-search/building-search.component */ "./src/app/views/building-search/building-search.component.ts");
/* harmony import */ var _components_privacy_policy_privacy_policy_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/privacy-policy/privacy-policy.component */ "./src/app/components/privacy-policy/privacy-policy.component.ts");
/* harmony import */ var _views_imprint_imprint_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./views/imprint/imprint.component */ "./src/app/views/imprint/imprint.component.ts");
/* harmony import */ var _views_subscription_subscription_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./views/subscription/subscription.component */ "./src/app/views/subscription/subscription.component.ts");
/* harmony import */ var _views_kiosk_mode_kiosk_mode_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./views/kiosk-mode/kiosk-mode.component */ "./src/app/views/kiosk-mode/kiosk-mode.component.ts");









const routes = [
    {
        path: '',
        component: _views_building_search_building_search_component__WEBPACK_IMPORTED_MODULE_4__["BuildingSearchComponent"],
        pathMatch: 'full'
    },
    {
        path: 'kiosk',
        component: _views_kiosk_mode_kiosk_mode_component__WEBPACK_IMPORTED_MODULE_8__["KioskModeComponent"]
    },
    {
        path: 'search',
        component: _views_building_search_building_search_component__WEBPACK_IMPORTED_MODULE_4__["BuildingSearchComponent"]
    },
    {
        path: 'board',
        redirectTo: ''
    },
    {
        path: 'demo',
        pathMatch: 'full',
        component: _views_home_home_component__WEBPACK_IMPORTED_MODULE_3__["HomeComponent"]
    },
    {
        path: 'privacy-policy',
        component: _components_privacy_policy_privacy_policy_component__WEBPACK_IMPORTED_MODULE_5__["PrivacyPolicyComponent"]
    },
    {
        path: 'imprint',
        component: _views_imprint_imprint_component__WEBPACK_IMPORTED_MODULE_6__["ImprintComponent"]
    },
    {
        path: 'subscribe/:idBuilding/:subscriptionGuid',
        component: _views_subscription_subscription_component__WEBPACK_IMPORTED_MODULE_7__["SubscriptionComponent"]
    },
    {
        path: 'unsubscribe/:idBuilding/:subscriptionGuid',
        component: _views_subscription_subscription_component__WEBPACK_IMPORTED_MODULE_7__["SubscriptionComponent"]
    },
    /* Use least-specific routes last. Angular takes the first matching route thaz consumes most of the URL., and any route would match ":id"
    but "/346/x" would prefer :id/:keycode since it consumes more of the URL */
    {
        path: ':boardKey',
        component: _views_home_home_component__WEBPACK_IMPORTED_MODULE_3__["HomeComponent"]
    },
    {
        path: ':boardKey/:keycode',
        component: _views_home_home_component__WEBPACK_IMPORTED_MODULE_3__["HomeComponent"]
    }
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.less":
/*!************************************!*\
  !*** ./src/app/app.component.less ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQubGVzcyJ9 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");



let AppComponent = 
// https://medium.com/@motcowley/angular-loading-screen-for-module-navigation-ac96c056b410
class AppComponent {
    constructor(cd) {
        this.cd = cd;
    }
    ngOnInit() {
        this.isLoading = true;
        document.title = src_environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].htmlDocumentTitle;
        this.hideCompanyLogo = src_environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].hideCompanyLogo;
    }
    ngAfterViewInit() {
        this.cd.detectChanges();
        setTimeout(() => {
            this.isLoading = false;
        }, 1000);
    }
};
AppComponent.ctorParameters = () => [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectorRef"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.less */ "./src/app/app.component.less")).default]
    })
    // https://medium.com/@motcowley/angular-loading-screen-for-module-navigation-ac96c056b410
    ,
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectorRef"]])
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var angularx_qrcode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! angularx-qrcode */ "./node_modules/angularx-qrcode/fesm2015/angularx-qrcode.js");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _components_house_number_plaque_house_number_plaque_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/house-number-plaque/house-number-plaque.component */ "./src/app/components/house-number-plaque/house-number-plaque.component.ts");
/* harmony import */ var _views_home_home_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./views/home/home.component */ "./src/app/views/home/home.component.ts");
/* harmony import */ var _components_tile_tile_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./components/tile/tile.component */ "./src/app/components/tile/tile.component.ts");
/* harmony import */ var _components_day_overview_tile_day_overview_tile_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./components/day-overview-tile/day-overview-tile.component */ "./src/app/components/day-overview-tile/day-overview-tile.component.ts");
/* harmony import */ var _components_day_names_motto_tile_day_names_motto_tile_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./components/day-names-motto-tile/day-names-motto-tile.component */ "./src/app/components/day-names-motto-tile/day-names-motto-tile.component.ts");
/* harmony import */ var _components_contact_tile_contact_tile_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./components/contact-tile/contact-tile.component */ "./src/app/components/contact-tile/contact-tile.component.ts");
/* harmony import */ var _components_topic_tile_topic_tile_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./components/topic-tile/topic-tile.component */ "./src/app/components/topic-tile/topic-tile.component.ts");
/* harmony import */ var _components_topic_list_tile_topic_list_tile_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./components/topic-list-tile/topic-list-tile.component */ "./src/app/components/topic-list-tile/topic-list-tile.component.ts");
/* harmony import */ var _components_scroll_to_top_scroll_to_top_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./components/scroll-to-top/scroll-to-top.component */ "./src/app/components/scroll-to-top/scroll-to-top.component.ts");
/* harmony import */ var _views_building_search_building_search_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./views/building-search/building-search.component */ "./src/app/views/building-search/building-search.component.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _components_appointment_tile_appointment_tile_component__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./components/appointment-tile/appointment-tile.component */ "./src/app/components/appointment-tile/appointment-tile.component.ts");
/* harmony import */ var _components_appointment_list_tile_appointment_list_tile_component__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./components/appointment-list-tile/appointment-list-tile.component */ "./src/app/components/appointment-list-tile/appointment-list-tile.component.ts");
/* harmony import */ var _components_privacy_banner_privacy_banner_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./components/privacy-banner/privacy-banner.component */ "./src/app/components/privacy-banner/privacy-banner.component.ts");
/* harmony import */ var _components_privacy_policy_privacy_policy_component__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./components/privacy-policy/privacy-policy.component */ "./src/app/components/privacy-policy/privacy-policy.component.ts");
/* harmony import */ var _views_imprint_imprint_component__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./views/imprint/imprint.component */ "./src/app/views/imprint/imprint.component.ts");
/* harmony import */ var _components_footer_footer_component__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./components/footer/footer.component */ "./src/app/components/footer/footer.component.ts");
/* harmony import */ var _components_backbutton_backbutton_component__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./components/backbutton/backbutton.component */ "./src/app/components/backbutton/backbutton.component.ts");
/* harmony import */ var _components_no_data_no_data_component__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./components/no-data/no-data.component */ "./src/app/components/no-data/no-data.component.ts");
/* harmony import */ var _handler_global_error_handler__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./handler/global-error.handler */ "./src/app/handler/global-error.handler.ts");
/* harmony import */ var _components_links_tile_links_tile_component__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./components/links-tile/links-tile.component */ "./src/app/components/links-tile/links-tile.component.ts");
/* harmony import */ var _components_canvas_clock_canvas_clock_component__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./components/canvas-clock/canvas-clock.component */ "./src/app/components/canvas-clock/canvas-clock.component.ts");
/* harmony import */ var _components_subscribe_tile_subscribe_tile_component__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./components/subscribe-tile/subscribe-tile.component */ "./src/app/components/subscribe-tile/subscribe-tile.component.ts");
/* harmony import */ var _views_subscription_subscription_component__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./views/subscription/subscription.component */ "./src/app/views/subscription/subscription.component.ts");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _components_carousel_carousel_component__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./components/carousel/carousel.component */ "./src/app/components/carousel/carousel.component.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _views_kiosk_mode_kiosk_mode_component__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./views/kiosk-mode/kiosk-mode.component */ "./src/app/views/kiosk-mode/kiosk-mode.component.ts");
/* harmony import */ var _components_kiosk_modal_kiosk_modal_component__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./components/kiosk-modal/kiosk-modal.component */ "./src/app/components/kiosk-modal/kiosk-modal.component.ts");
/* harmony import */ var _components_qrcode_tile_qrcode_tile_component__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./components/qrcode-tile/qrcode-tile.component */ "./src/app/components/qrcode-tile/qrcode-tile.component.ts");





































let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_6__["AppComponent"],
            _components_house_number_plaque_house_number_plaque_component__WEBPACK_IMPORTED_MODULE_7__["HouseNumberPlaqueComponent"],
            _views_home_home_component__WEBPACK_IMPORTED_MODULE_8__["HomeComponent"],
            _components_tile_tile_component__WEBPACK_IMPORTED_MODULE_9__["TileComponent"],
            _components_day_overview_tile_day_overview_tile_component__WEBPACK_IMPORTED_MODULE_10__["DayOverviewTileComponent"],
            _components_day_names_motto_tile_day_names_motto_tile_component__WEBPACK_IMPORTED_MODULE_11__["DayNamesMottoTileComponent"],
            _components_contact_tile_contact_tile_component__WEBPACK_IMPORTED_MODULE_12__["ContactTileComponent"],
            _components_topic_tile_topic_tile_component__WEBPACK_IMPORTED_MODULE_13__["TopicTileComponent"],
            _components_topic_list_tile_topic_list_tile_component__WEBPACK_IMPORTED_MODULE_14__["TopicListTileComponent"],
            _components_scroll_to_top_scroll_to_top_component__WEBPACK_IMPORTED_MODULE_15__["ScrollToTopComponent"],
            _views_building_search_building_search_component__WEBPACK_IMPORTED_MODULE_16__["BuildingSearchComponent"],
            _components_appointment_tile_appointment_tile_component__WEBPACK_IMPORTED_MODULE_18__["AppointmentTileComponent"],
            _components_appointment_list_tile_appointment_list_tile_component__WEBPACK_IMPORTED_MODULE_19__["AppointmentListTileComponent"],
            _components_privacy_banner_privacy_banner_component__WEBPACK_IMPORTED_MODULE_20__["PrivacyBannerComponent"],
            _components_privacy_policy_privacy_policy_component__WEBPACK_IMPORTED_MODULE_21__["PrivacyPolicyComponent"],
            _views_imprint_imprint_component__WEBPACK_IMPORTED_MODULE_22__["ImprintComponent"],
            _components_footer_footer_component__WEBPACK_IMPORTED_MODULE_23__["FooterComponent"],
            _components_backbutton_backbutton_component__WEBPACK_IMPORTED_MODULE_24__["BackbuttonComponent"],
            _components_no_data_no_data_component__WEBPACK_IMPORTED_MODULE_25__["NoDataComponent"],
            _components_links_tile_links_tile_component__WEBPACK_IMPORTED_MODULE_27__["LinksTileComponent"],
            _components_canvas_clock_canvas_clock_component__WEBPACK_IMPORTED_MODULE_28__["CanvasClockComponent"],
            _components_subscribe_tile_subscribe_tile_component__WEBPACK_IMPORTED_MODULE_29__["SubscribeTileComponent"],
            _views_subscription_subscription_component__WEBPACK_IMPORTED_MODULE_30__["SubscriptionComponent"],
            _components_carousel_carousel_component__WEBPACK_IMPORTED_MODULE_32__["CarouselComponent"],
            _views_kiosk_mode_kiosk_mode_component__WEBPACK_IMPORTED_MODULE_34__["KioskModeComponent"],
            _components_kiosk_modal_kiosk_modal_component__WEBPACK_IMPORTED_MODULE_35__["KioskModalComponent"],
            _components_qrcode_tile_qrcode_tile_component__WEBPACK_IMPORTED_MODULE_36__["QrcodeTileComponent"],
        ],
        entryComponents: [
            _components_kiosk_modal_kiosk_modal_component__WEBPACK_IMPORTED_MODULE_35__["KioskModalComponent"]
        ],
        exports: [
            _components_kiosk_modal_kiosk_modal_component__WEBPACK_IMPORTED_MODULE_35__["KioskModalComponent"]
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_4__["AppRoutingModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClientModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_17__["FormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_17__["ReactiveFormsModule"],
            _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_31__["NgbCarouselModule"],
            _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_31__["NgbModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_33__["BrowserAnimationsModule"],
            angularx_qrcode__WEBPACK_IMPORTED_MODULE_5__["QRCodeModule"],
        ],
        providers: [{
                provide: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ErrorHandler"],
                useClass: _handler_global_error_handler__WEBPACK_IMPORTED_MODULE_26__["GlobalErrorHandler"]
            }],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_6__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/components/appointment-list-tile/appointment-list-tile.component.less":
/*!***************************************************************************************!*\
  !*** ./src/app/components/appointment-list-tile/appointment-list-tile.component.less ***!
  \***************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvYXBwb2ludG1lbnQtbGlzdC10aWxlL2FwcG9pbnRtZW50LWxpc3QtdGlsZS5jb21wb25lbnQubGVzcyJ9 */");

/***/ }),

/***/ "./src/app/components/appointment-list-tile/appointment-list-tile.component.ts":
/*!*************************************************************************************!*\
  !*** ./src/app/components/appointment-list-tile/appointment-list-tile.component.ts ***!
  \*************************************************************************************/
/*! exports provided: AppointmentListTileComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppointmentListTileComponent", function() { return AppointmentListTileComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AppointmentListTileComponent = class AppointmentListTileComponent {
    constructor() {
        this.moreClick = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
    }
    ngOnInit() {
    }
    moreClicked(slideId) {
        this.moreClick.emit(slideId);
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Array)
], AppointmentListTileComponent.prototype, "models", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], AppointmentListTileComponent.prototype, "moreClick", void 0);
AppointmentListTileComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-appointment-list-tile',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./appointment-list-tile.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/appointment-list-tile/appointment-list-tile.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./appointment-list-tile.component.less */ "./src/app/components/appointment-list-tile/appointment-list-tile.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], AppointmentListTileComponent);



/***/ }),

/***/ "./src/app/components/appointment-tile/appointment-tile.component.less":
/*!*****************************************************************************!*\
  !*** ./src/app/components/appointment-tile/appointment-tile.component.less ***!
  \*****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvYXBwb2ludG1lbnQtdGlsZS9hcHBvaW50bWVudC10aWxlLmNvbXBvbmVudC5sZXNzIn0= */");

/***/ }),

/***/ "./src/app/components/appointment-tile/appointment-tile.component.ts":
/*!***************************************************************************!*\
  !*** ./src/app/components/appointment-tile/appointment-tile.component.ts ***!
  \***************************************************************************/
/*! exports provided: AppointmentTileComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppointmentTileComponent", function() { return AppointmentTileComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_download_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/download.service */ "./src/app/services/download.service.ts");
/* harmony import */ var src_app_models_appointment_model__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/models/appointment-model */ "./src/app/models/appointment-model.ts");




let AppointmentTileComponent = class AppointmentTileComponent {
    constructor(downloadService) {
        this.downloadService = downloadService;
        this.backClick = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
    }
    ngOnInit() {
    }
    backClicked() {
        this.backClick.emit(null);
    }
    downloadAttachment() {
        this.downloadService.downloadFile(this.model.attachment);
        return false;
    }
};
AppointmentTileComponent.ctorParameters = () => [
    { type: src_app_services_download_service__WEBPACK_IMPORTED_MODULE_2__["DownloadService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", src_app_models_appointment_model__WEBPACK_IMPORTED_MODULE_3__["AppointmentModel"])
], AppointmentTileComponent.prototype, "model", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], AppointmentTileComponent.prototype, "backClick", void 0);
AppointmentTileComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-appointment-tile',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./appointment-tile.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/appointment-tile/appointment-tile.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./appointment-tile.component.less */ "./src/app/components/appointment-tile/appointment-tile.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [src_app_services_download_service__WEBPACK_IMPORTED_MODULE_2__["DownloadService"]])
], AppointmentTileComponent);



/***/ }),

/***/ "./src/app/components/backbutton/backbutton.component.less":
/*!*****************************************************************!*\
  !*** ./src/app/components/backbutton/backbutton.component.less ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".back-button {\n  position: fixed;\n  top: 50%;\n  left: 20px;\n  background: rgba(153, 153, 153, 0.9);\n  border-radius: 4px;\n  color: #FFF;\n  padding: 1em 1.3em 0.9em;\n  cursor: pointer;\n  z-index: 666;\n  transition: all 0.2s ease-in-out;\n}\n.back-button i {\n  border: solid #fff;\n  border-width: 0 6px 6px 0;\n  display: inline-block;\n  padding: 3px;\n}\n.back-button i.left {\n  transform: rotate(225deg);\n  -webkit-transform: rotate(-225deg);\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50cy9iYWNrYnV0dG9uL0M6L19kZXYvU291cmNlL1JlcG9zL1NjaHdhcnplc0JyZXR0LkluZm9ib2FyZHNXZWIvaW5mb2JvYXJkc3dlYi1hcHAvc3JjL2FwcC9jb21wb25lbnRzL2JhY2tidXR0b24vYmFja2J1dHRvbi5jb21wb25lbnQubGVzcyIsInNyYy9hcHAvY29tcG9uZW50cy9iYWNrYnV0dG9uL2JhY2tidXR0b24uY29tcG9uZW50Lmxlc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxlQUFBO0VBQ0EsUUFBQTtFQUNBLFVBQUE7RUFDQSxvQ0FBQTtFQUNBLGtCQUFBO0VBQ0EsV0FBQTtFQUNBLHdCQUFBO0VBQ0EsZUFBQTtFQUNBLFlBQUE7RUFDQSxnQ0FBQTtBQ0NGO0FEWEE7RUFZTSxrQkFBQTtFQUNBLHlCQUFBO0VBQ0EscUJBQUE7RUFDQSxZQUFBO0FDRU47QURqQkE7RUFrQk0seUJBQUE7RUFDQSxrQ0FBQTtBQ0VOIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50cy9iYWNrYnV0dG9uL2JhY2tidXR0b24uY29tcG9uZW50Lmxlc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuYmFjay1idXR0b24ge1xuICBwb3NpdGlvbjogZml4ZWQ7XG4gIHRvcDogNTAlO1xuICBsZWZ0OiAyMHB4O1xuICBiYWNrZ3JvdW5kOiByZ2JhKDE1MywxNTMsMTUzLDAuOSk7XG4gIGJvcmRlci1yYWRpdXM6IDRweDtcbiAgY29sb3I6ICNGRkY7XG4gIHBhZGRpbmc6IDFlbSAxLjNlbSAwLjllbTtcbiAgY3Vyc29yOiBwb2ludGVyO1xuICB6LWluZGV4OiA2NjY7XG4gIHRyYW5zaXRpb246IGFsbCAuMnMgZWFzZS1pbi1vdXQ7XG4gIGkge1xuICAgICAgYm9yZGVyOiBzb2xpZCAjZmZmO1xuICAgICAgYm9yZGVyLXdpZHRoOiAwIDZweCA2cHggMDtcbiAgICAgIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgICAgIHBhZGRpbmc6IDNweDtcbiAgfVxuICBpLmxlZnQge1xuICAgICAgdHJhbnNmb3JtOiByb3RhdGUoMjI1ZGVnKTtcbiAgICAgIC13ZWJraXQtdHJhbnNmb3JtOiByb3RhdGUoLTIyNWRlZyk7XG4gIH1cbiB9XG5cbiIsIi5iYWNrLWJ1dHRvbiB7XG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgdG9wOiA1MCU7XG4gIGxlZnQ6IDIwcHg7XG4gIGJhY2tncm91bmQ6IHJnYmEoMTUzLCAxNTMsIDE1MywgMC45KTtcbiAgYm9yZGVyLXJhZGl1czogNHB4O1xuICBjb2xvcjogI0ZGRjtcbiAgcGFkZGluZzogMWVtIDEuM2VtIDAuOWVtO1xuICBjdXJzb3I6IHBvaW50ZXI7XG4gIHotaW5kZXg6IDY2NjtcbiAgdHJhbnNpdGlvbjogYWxsIDAuMnMgZWFzZS1pbi1vdXQ7XG59XG4uYmFjay1idXR0b24gaSB7XG4gIGJvcmRlcjogc29saWQgI2ZmZjtcbiAgYm9yZGVyLXdpZHRoOiAwIDZweCA2cHggMDtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICBwYWRkaW5nOiAzcHg7XG59XG4uYmFjay1idXR0b24gaS5sZWZ0IHtcbiAgdHJhbnNmb3JtOiByb3RhdGUoMjI1ZGVnKTtcbiAgLXdlYmtpdC10cmFuc2Zvcm06IHJvdGF0ZSgtMjI1ZGVnKTtcbn1cbiJdfQ== */");

/***/ }),

/***/ "./src/app/components/backbutton/backbutton.component.ts":
/*!***************************************************************!*\
  !*** ./src/app/components/backbutton/backbutton.component.ts ***!
  \***************************************************************/
/*! exports provided: BackbuttonComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BackbuttonComponent", function() { return BackbuttonComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let BackbuttonComponent = class BackbuttonComponent {
    constructor() { }
    ngOnInit() {
    }
};
BackbuttonComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-backbutton',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./backbutton.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/backbutton/backbutton.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./backbutton.component.less */ "./src/app/components/backbutton/backbutton.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], BackbuttonComponent);



/***/ }),

/***/ "./src/app/components/canvas-clock/TDate.ts":
/*!**************************************************!*\
  !*** ./src/app/components/canvas-clock/TDate.ts ***!
  \**************************************************/
/*! exports provided: TDate */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TDate", function() { return TDate; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

/**
 * Easily Destructure Date Object
 */
class TDate {
    constructor(date) {
        this.date = date;
    }
    get seconds() {
        return this.date.getSeconds();
    }
    get minutes() {
        return this.date.getMinutes();
    }
    get hours() {
        return this.date.getHours();
    }
    get month() {
        return this.date.getMonth() + 1;
    }
    get day() {
        return this.date.getDate();
    }
    get year() {
        return this.date.getFullYear();
    }
}


/***/ }),

/***/ "./src/app/components/canvas-clock/canvas-clock.component.less":
/*!*********************************************************************!*\
  !*** ./src/app/components/canvas-clock/canvas-clock.component.less ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvY2FudmFzLWNsb2NrL2NhbnZhcy1jbG9jay5jb21wb25lbnQubGVzcyJ9 */");

/***/ }),

/***/ "./src/app/components/canvas-clock/canvas-clock.component.ts":
/*!*******************************************************************!*\
  !*** ./src/app/components/canvas-clock/canvas-clock.component.ts ***!
  \*******************************************************************/
/*! exports provided: CanvasClockComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CanvasClockComponent", function() { return CanvasClockComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _TDate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./TDate */ "./src/app/components/canvas-clock/TDate.ts");






let CanvasClockComponent = class CanvasClockComponent {
    constructor(ngZone) {
        this.ngZone = ngZone;
        this.width = 500;
        this.height = 500;
    }
    ngOnInit() { }
    ngAfterViewInit() {
        const canvasEl = this.canvasRef.nativeElement;
        canvasEl.width = this.width;
        canvasEl.height = this.height;
        const radius = canvasEl.height / 2;
        const innerRadius = radius * 0.9;
        this.canvasContext = canvasEl.getContext('2d');
        this.canvasContext.translate(radius, radius);
        this.ngZone.runOutsideAngular(() => this.draw(innerRadius));
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    draw(innerRadius) {
        this.subscription = Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["timer"])(0, 1000)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(t => {
            this.drawFace(this.canvasContext, innerRadius);
            this.drawNumbers(this.canvasContext, innerRadius);
            this.drawTime(this.canvasContext, innerRadius);
        }))
            .subscribe();
    }
    drawFace(ctx, radius) {
        ctx.beginPath();
        ctx.arc(0, 0, radius, 0, 2 * Math.PI);
        ctx.fillStyle = 'white';
        ctx.fill();
        // This adds a gradient round border around the clock
        // const grad = ctx.createRadialGradient(0, 0, radius * 0.95, 0, 0, radius * 1.05);
        // grad.addColorStop(0, '#333');
        // grad.addColorStop(0.5, 'white');
        // grad.addColorStop(1, '#333');
        // ctx.strokeStyle = grad;
        // ctx.lineWidth = radius * 0.1;
        // ctx.stroke();
        ctx.beginPath();
        ctx.arc(0, 0, radius * 0.1, 0, 2 * Math.PI);
        ctx.fillStyle = '#333';
        ctx.fill();
    }
    drawNumbers(ctx, radius) {
        let ang;
        let num;
        ctx.font = radius * 0.225 + 'px Montserrat, sans-serif';
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'center';
        for (num = 1; num < 13; num++) {
            ang = num * Math.PI / 6;
            ctx.rotate(ang);
            ctx.translate(0, -radius * 0.85);
            ctx.rotate(-ang);
            ctx.fillText(num.toString(), 0, 0);
            ctx.rotate(ang);
            ctx.translate(0, radius * 0.85);
            ctx.rotate(-ang);
        }
    }
    drawTime(ctx, radius) {
        const { seconds, minutes, hours } = new _TDate__WEBPACK_IMPORTED_MODULE_4__["TDate"](new Date());
        const hourHand = (hours % 12) * Math.PI / 6 + minutes * Math.PI / (6 * 60) + seconds * Math.PI / (360 * 60);
        this.drawHand(ctx, hourHand, radius * 0.5, radius * 0.06);
        const minuteHand = minutes * Math.PI / 30 + seconds * Math.PI / (30 * 60);
        this.drawHand(ctx, minuteHand, radius * 0.8, radius * 0.04);
        const secondHand = seconds * Math.PI / 30;
        this.drawHand(ctx, secondHand, radius * 0.9, radius * 0.02);
    }
    drawHand(ctx, pos, length, width) {
        ctx.beginPath();
        ctx.lineWidth = width;
        ctx.lineCap = 'round';
        ctx.moveTo(0, 0);
        ctx.rotate(pos);
        ctx.lineTo(0, -length);
        ctx.stroke();
        ctx.rotate(-pos);
    }
};
CanvasClockComponent.ctorParameters = () => [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('canvasClock', { static: true }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_core__WEBPACK_IMPORTED_MODULE_1__["ElementRef"])
], CanvasClockComponent.prototype, "canvasRef", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], CanvasClockComponent.prototype, "width", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], CanvasClockComponent.prototype, "height", void 0);
CanvasClockComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-canvas-clock',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./canvas-clock.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/canvas-clock/canvas-clock.component.html")).default,
        changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ChangeDetectionStrategy"].OnPush,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./canvas-clock.component.less */ "./src/app/components/canvas-clock/canvas-clock.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgZone"]])
], CanvasClockComponent);



/***/ }),

/***/ "./src/app/components/carousel/ESlideState.ts":
/*!****************************************************!*\
  !*** ./src/app/components/carousel/ESlideState.ts ***!
  \****************************************************/
/*! exports provided: ESlideState */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ESlideState", function() { return ESlideState; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

var ESlideState;
(function (ESlideState) {
    ESlideState["Active"] = "active";
    ESlideState["ActiveLeft"] = "activeLeft";
    ESlideState["ActiveRight"] = "activeRight";
    ESlideState["PreviousLeft"] = "previousLeft";
    ESlideState["PreviousRight"] = "previousRight";
    ESlideState["Hidden"] = "hidden";
})(ESlideState || (ESlideState = {}));


/***/ }),

/***/ "./src/app/components/carousel/carousel.component.less":
/*!*************************************************************!*\
  !*** ./src/app/components/carousel/carousel.component.less ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvY2Fyb3VzZWwvY2Fyb3VzZWwuY29tcG9uZW50Lmxlc3MifQ== */");

/***/ }),

/***/ "./src/app/components/carousel/carousel.component.ts":
/*!***********************************************************!*\
  !*** ./src/app/components/carousel/carousel.component.ts ***!
  \***********************************************************/
/*! exports provided: CarouselComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CarouselComponent", function() { return CarouselComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
/* harmony import */ var _ESlideState__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ESlideState */ "./src/app/components/carousel/ESlideState.ts");






let CarouselComponent = class CarouselComponent extends _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_3__["NgbCarousel"] {
    constructor() {
        super(...arguments);
        this.slideStates = {};
    }
    getSlideById(slideId) {
        return this.slides.find(slide => slide.id === slideId);
    }
    getSlideIndexById(slideId) {
        return this.slides.toArray().indexOf(this.getSlideById(slideId));
    }
    getSlideEventDirection(currentActiveSlideId, nextActiveSlideId) {
        const currentIndex = this.getSlideIndexById(currentActiveSlideId);
        const nextIndex = this.getSlideIndexById(nextActiveSlideId);
        const lastIndex = this.slides.length - 1;
        const firstIndex = 0;
        return currentIndex <= nextIndex &&
            !(currentIndex === firstIndex && nextIndex === lastIndex) ||
            currentIndex === lastIndex && nextIndex === firstIndex
            ? _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_3__["NgbSlideEventDirection"].LEFT
            : _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_3__["NgbSlideEventDirection"].RIGHT;
    }
    getSlideState(id) {
        let result = this.slideStates[id];
        if (!result) {
            result = new rxjs__WEBPACK_IMPORTED_MODULE_1__["BehaviorSubject"](this.getSlideStateAtSlide(id, this.activeId));
            this.slideStates[id] = result;
        }
        return result;
    }
    getSlideStateAtSlide(id, current, prev) {
        let result;
        if (!prev) {
            result = current === id ? _ESlideState__WEBPACK_IMPORTED_MODULE_5__["ESlideState"].Active : _ESlideState__WEBPACK_IMPORTED_MODULE_5__["ESlideState"].Hidden;
        }
        else {
            const direction = this.getSlideEventDirection(prev, current);
            switch (direction) {
                case _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_3__["NgbSlideEventDirection"].LEFT:
                    result = current === id ? _ESlideState__WEBPACK_IMPORTED_MODULE_5__["ESlideState"].ActiveLeft : prev === id ? _ESlideState__WEBPACK_IMPORTED_MODULE_5__["ESlideState"].PreviousLeft : _ESlideState__WEBPACK_IMPORTED_MODULE_5__["ESlideState"].Hidden;
                    break;
                case _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_3__["NgbSlideEventDirection"].RIGHT:
                    result = current === id ? _ESlideState__WEBPACK_IMPORTED_MODULE_5__["ESlideState"].ActiveRight : prev === id ? _ESlideState__WEBPACK_IMPORTED_MODULE_5__["ESlideState"].PreviousRight : _ESlideState__WEBPACK_IMPORTED_MODULE_5__["ESlideState"].Hidden;
                    break;
                default:
                    result = _ESlideState__WEBPACK_IMPORTED_MODULE_5__["ESlideState"].Hidden;
                    break;
            }
        }
        return result;
    }
    ngOnInit() {
        this.slidesSubscription = this.slide.subscribe((event) => {
            for (const slideId of Object.keys(this.slideStates)) {
                const slideState = this.slideStates[slideId];
                slideState.next(this.getSlideStateAtSlide(slideId, event.current, event.prev));
            }
        });
    }
    ngOnDestroy() {
        this.slidesSubscription.unsubscribe();
    }
    swipe(e, when) {
        const coord = [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
        const time = new Date().getTime();
        if (when === 'start') {
            this.swipeCoord = coord;
            this.swipeTime = time;
        }
        else if (when === 'end') {
            const direction = [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
            const duration = time - this.swipeTime;
            if (duration < 1000
                && Math.abs(direction[0]) > 30 // Long enough
                && Math.abs(direction[0]) > Math.abs(direction[1] * 3)) { // Horizontal enough
                const swipe = direction[0] < 0 ? 'next' : 'previous';
                if (swipe == 'next')
                    this.next();
                else
                    this.prev();
            }
        }
    }
};
CarouselComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: 'app-carousel',
        animations: [
            Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["trigger"])('slide', [
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["state"])('hidden, previousLeft, previousRight', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({
                    display: 'none',
                    opacity: 0
                })),
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["transition"])(':enter', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({
                        display: 'none'
                    }),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["animate"])('0s')
                ]),
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["transition"])('* => *', [
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["style"])({
                        display: 'block'
                    }),
                    Object(_angular_animations__WEBPACK_IMPORTED_MODULE_4__["animate"])('0.6s 0s ease')
                ])
            ])
        ],
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./carousel.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/carousel/carousel.component.html")).default,
        changeDetection: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ChangeDetectionStrategy"].OnPush,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./carousel.component.less */ "./src/app/components/carousel/carousel.component.less")).default]
    })
], CarouselComponent);



/***/ }),

/***/ "./src/app/components/contact-tile/contact-tile.component.less":
/*!*********************************************************************!*\
  !*** ./src/app/components/contact-tile/contact-tile.component.less ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvY29udGFjdC10aWxlL2NvbnRhY3QtdGlsZS5jb21wb25lbnQubGVzcyJ9 */");

/***/ }),

/***/ "./src/app/components/contact-tile/contact-tile.component.ts":
/*!*******************************************************************!*\
  !*** ./src/app/components/contact-tile/contact-tile.component.ts ***!
  \*******************************************************************/
/*! exports provided: ContactTileComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContactTileComponent", function() { return ContactTileComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_models_contacts_contact_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/models/contacts/contact-model */ "./src/app/models/contacts/contact-model.ts");
/* harmony import */ var src_app_services_kiosk_mode_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/kiosk-mode.service */ "./src/app/services/kiosk-mode.service.ts");




let ContactTileComponent = class ContactTileComponent {
    constructor(kioskModeService) {
        this.kioskModeService = kioskModeService;
    }
    ngOnInit() { }
    onClick(event) {
        if (!this.kioskModeService.isKioskMode) {
            // When not in kiosk mode, do everything as normal. Don't intercept click
            return true;
        }
        if (event.target.tagName === 'A' && event.target.href && event.target.href.startsWith('http')) {
            this.kioskModeService.openModal(event.target.href);
        }
        // returning false here is equal to event.preventDefault()
        return false;
    }
    isNullOrUndefined(obj) {
        // null == undefined so this is true if obj = null or obj = undefined
        return obj == null;
    }
};
ContactTileComponent.ctorParameters = () => [
    { type: src_app_services_kiosk_mode_service__WEBPACK_IMPORTED_MODULE_3__["KioskModeService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", src_app_models_contacts_contact_model__WEBPACK_IMPORTED_MODULE_2__["ContactModel"])
], ContactTileComponent.prototype, "model", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])('click', ['$event']),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Function),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [Object]),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:returntype", void 0)
], ContactTileComponent.prototype, "onClick", null);
ContactTileComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-contact-tile',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./contact-tile.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/contact-tile/contact-tile.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./contact-tile.component.less */ "./src/app/components/contact-tile/contact-tile.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [src_app_services_kiosk_mode_service__WEBPACK_IMPORTED_MODULE_3__["KioskModeService"]])
], ContactTileComponent);



/***/ }),

/***/ "./src/app/components/day-names-motto-tile/day-names-motto-tile.component.less":
/*!*************************************************************************************!*\
  !*** ./src/app/components/day-names-motto-tile/day-names-motto-tile.component.less ***!
  \*************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvZGF5LW5hbWVzLW1vdHRvLXRpbGUvZGF5LW5hbWVzLW1vdHRvLXRpbGUuY29tcG9uZW50Lmxlc3MifQ== */");

/***/ }),

/***/ "./src/app/components/day-names-motto-tile/day-names-motto-tile.component.ts":
/*!***********************************************************************************!*\
  !*** ./src/app/components/day-names-motto-tile/day-names-motto-tile.component.ts ***!
  \***********************************************************************************/
/*! exports provided: DayNamesMottoTileComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DayNamesMottoTileComponent", function() { return DayNamesMottoTileComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/portego.service */ "./src/app/services/portego.service.ts");
/* harmony import */ var src_app_helper_datetime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/helper/datetime */ "./src/app/helper/datetime.ts");




let DayNamesMottoTileComponent = class DayNamesMottoTileComponent {
    constructor(portegoService) {
        this.portegoService = portegoService;
        this.portegoService = portegoService;
    }
    ngOnInit() {
        this.setCurrentDate();
        this.getNamesOfTheDay();
        this.getSloganOfTheWeek();
    }
    setCurrentDate() {
        const today = new Date();
        this.day = today.getDate();
        this.month = today.getMonth() + 1;
        this.week = new src_app_helper_datetime__WEBPACK_IMPORTED_MODULE_3__["DateTime"]().getCurrentWeekNumber();
    }
    getNamesOfTheDay() {
        this.portegoService.getNamesOfTheDay().subscribe(data => {
            this.nameDays = data;
            this.names = this.nameDays.find(p => p.day === this.day && p.month === this.month).text;
        });
    }
    getSloganOfTheWeek() {
        this.portegoService.getSloganOfTheWeek().subscribe(data => {
            this.slogans = data;
            this.slogan = this.slogans.find(p => p.week === this.week).text;
        });
    }
};
DayNamesMottoTileComponent.ctorParameters = () => [
    { type: src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_2__["PortegoService"] }
];
DayNamesMottoTileComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-day-names-motto-tile',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./day-names-motto-tile.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/day-names-motto-tile/day-names-motto-tile.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./day-names-motto-tile.component.less */ "./src/app/components/day-names-motto-tile/day-names-motto-tile.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_2__["PortegoService"]])
], DayNamesMottoTileComponent);



/***/ }),

/***/ "./src/app/components/day-overview-tile/day-overview-tile.component.less":
/*!*******************************************************************************!*\
  !*** ./src/app/components/day-overview-tile/day-overview-tile.component.less ***!
  \*******************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvZGF5LW92ZXJ2aWV3LXRpbGUvZGF5LW92ZXJ2aWV3LXRpbGUuY29tcG9uZW50Lmxlc3MifQ== */");

/***/ }),

/***/ "./src/app/components/day-overview-tile/day-overview-tile.component.ts":
/*!*****************************************************************************!*\
  !*** ./src/app/components/day-overview-tile/day-overview-tile.component.ts ***!
  \*****************************************************************************/
/*! exports provided: DayOverviewTileComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DayOverviewTileComponent", function() { return DayOverviewTileComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! util */ "./node_modules/util/util.js");
/* harmony import */ var util__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(util__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_app_models_weather_weather_of_the_day_model__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/models/weather/weather-of-the-day-model */ "./src/app/models/weather/weather-of-the-day-model.ts");
/* harmony import */ var src_app_helper_openWeatherMap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/helper/openWeatherMap */ "./src/app/helper/openWeatherMap.ts");
/* harmony import */ var src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/services/portego.service */ "./src/app/services/portego.service.ts");
/* harmony import */ var src_app_helper_datetime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/helper/datetime */ "./src/app/helper/datetime.ts");







let DayOverviewTileComponent = class DayOverviewTileComponent {
    constructor(weatherProvider, portegoService) {
        this.weatherProvider = weatherProvider;
        this.portegoService = portegoService;
        this.currentDay = new src_app_helper_datetime__WEBPACK_IMPORTED_MODULE_6__["DateTime"]().getCurrentDate();
        this.model = new src_app_models_weather_weather_of_the_day_model__WEBPACK_IMPORTED_MODULE_3__["WeatherOfTheDayModel"]();
        this.date = new Date();
    }
    ngOnInit() {
        this.portegoService.getBuildingAdress(this.idBuilding).subscribe(data => {
            const address = data;
            this.city = Object(util__WEBPACK_IMPORTED_MODULE_2__["isNullOrUndefined"])(address.city) ? 'Denpasar' : address.city;
            this.initLocalWeather();
        });
    }
    ngAfterViewInit() {
        this.initLocalClocks();
    }
    initLocalWeather() {
        this.weatherProvider.getData(this.city).then(data => {
            const model = new src_app_models_weather_weather_of_the_day_model__WEBPACK_IMPORTED_MODULE_3__["WeatherOfTheDayModel"]();
            // model.temp = data[1]['list'][0].temp;
            model.weather = data[0]['weather'][0];
            model.temp.day = Math.round(data[0]['main'].temp);
            // model.temp.eve = Math.round(model.temp.eve);
            // model.temp.morn = Math.round(model.temp.morn);
            // model.temp.night = Math.round(model.temp.night);
            model.iconClass = this.weatherProvider.getIconPath(data[0]['weather'][0].id);
            this.model = model;
        });
    }
    initLocalClocks() {
        const date = this.date;
        const seconds = date.getSeconds();
        const minutes = date.getMinutes();
        const hours = date.getHours();
        const hands = [
            {
                hand: 'hours',
                angle: (hours * 30) + (minutes / 2)
            },
            {
                hand: 'minutes',
                angle: (minutes * 6)
            },
            {
                hand: 'seconds',
                angle: (seconds * 6)
            }
        ];
        for (let j = 0; j < hands.length; j++) {
            const elements = document.querySelectorAll('.' + hands[j].hand);
            elements.forEach((element) => {
                element.setAttribute('style', '-webkit-transform: rotateZ(' + hands[j].angle + 'deg)');
                element.setAttribute('transform', 'rotateZ(' + hands[j].angle + 'deg)');
                element.setAttribute('transform', 'rotateZ(' + hands[j].angle + 'deg)');
                // If this is a minute hand, note the seconds position (to calculate minute position later)
                if (hands[j].hand === 'minutes') {
                    element.parentElement.setAttribute('data-second-angle', hands[j + 1].angle.toString());
                }
            });
        }
    }
    /*
   * Set a timeout for the first minute hand movement (less than 1 minute), then rotate it every minute after that
   */
    setUpMinuteHands() {
        // Find out how far into the minute we are
        const containers = document.querySelectorAll('.minutes-container');
        const secondAngle = +(containers[0].getAttribute('data-second-angle'));
        if (secondAngle > 0) {
            // Set a timeout until the end of the current minute, to move the hand
            const delay = (((360 - secondAngle) / 6) + 0.1) * 1000;
            setTimeout(function () {
                this.moveMinuteHands(containers);
            }, delay);
        }
    }
    /*
     * Do the first minute's rotation
     */
    moveMinuteHands(containers) {
        for (let i = 0; i < containers.length; i++) {
            containers[i].setAttribute('style', '-webkit-transform: rotateZ(6deg)');
            containers[i].setAttribute('transform', 'rotateZ(6deg)');
        }
        // Then continue with a 60 second interval
        setInterval(function () {
            for (let i = 0; i < containers.length; i++) {
                if (containers[i].angle === undefined) {
                    containers[i].angle = 12;
                }
                else {
                    containers[i].angle += 6;
                }
                containers[i].style.webkitTransform = 'rotateZ(' + containers[i].angle + 'deg)';
                containers[i].style.transform = 'rotateZ(' + containers[i].angle + 'deg)';
            }
        }, 60000);
    }
};
DayOverviewTileComponent.ctorParameters = () => [
    { type: src_app_helper_openWeatherMap__WEBPACK_IMPORTED_MODULE_4__["OpenWeatherMap"] },
    { type: src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_5__["PortegoService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], DayOverviewTileComponent.prototype, "idBuilding", void 0);
DayOverviewTileComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-day-overview-tile',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./day-overview-tile.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/day-overview-tile/day-overview-tile.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./day-overview-tile.component.less */ "./src/app/components/day-overview-tile/day-overview-tile.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [src_app_helper_openWeatherMap__WEBPACK_IMPORTED_MODULE_4__["OpenWeatherMap"], src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_5__["PortegoService"]])
], DayOverviewTileComponent);



/***/ }),

/***/ "./src/app/components/footer/footer.component.less":
/*!*********************************************************!*\
  !*** ./src/app/components/footer/footer.component.less ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvZm9vdGVyL2Zvb3Rlci5jb21wb25lbnQubGVzcyJ9 */");

/***/ }),

/***/ "./src/app/components/footer/footer.component.ts":
/*!*******************************************************!*\
  !*** ./src/app/components/footer/footer.component.ts ***!
  \*******************************************************/
/*! exports provided: FooterComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FooterComponent", function() { return FooterComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! util */ "./node_modules/util/util.js");
/* harmony import */ var util__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(util__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");





let FooterComponent = class FooterComponent {
    constructor(router) {
        this.router = router;
    }
    ngOnInit() {
        this.isSingleBuildingMode = src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].singleBuildingModeBoardKey !== undefined && src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].singleBuildingModeBoardKey !== null;
    }
    searchClicked() {
        const boardKey = localStorage.getItem('board-key');
        if (!Object(util__WEBPACK_IMPORTED_MODULE_3__["isNullOrUndefined"])(boardKey)) {
            localStorage.removeItem('board-key');
        }
        this.router.navigate(['search']);
    }
};
FooterComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
FooterComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-footer',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./footer.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/footer/footer.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./footer.component.less */ "./src/app/components/footer/footer.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"]])
], FooterComponent);



/***/ }),

/***/ "./src/app/components/house-number-plaque/house-number-plaque.component.less":
/*!***********************************************************************************!*\
  !*** ./src/app/components/house-number-plaque/house-number-plaque.component.less ***!
  \***********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvaG91c2UtbnVtYmVyLXBsYXF1ZS9ob3VzZS1udW1iZXItcGxhcXVlLmNvbXBvbmVudC5sZXNzIn0= */");

/***/ }),

/***/ "./src/app/components/house-number-plaque/house-number-plaque.component.ts":
/*!*********************************************************************************!*\
  !*** ./src/app/components/house-number-plaque/house-number-plaque.component.ts ***!
  \*********************************************************************************/
/*! exports provided: HouseNumberPlaqueComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HouseNumberPlaqueComponent", function() { return HouseNumberPlaqueComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_models_building_address_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/models/building-address-model */ "./src/app/models/building-address-model.ts");
/* harmony import */ var src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/portego.service */ "./src/app/services/portego.service.ts");




let HouseNumberPlaqueComponent = class HouseNumberPlaqueComponent {
    constructor(portegoService) {
        this.portegoService = portegoService;
    }
    ngOnInit() {
        this.model = new src_app_models_building_address_model__WEBPACK_IMPORTED_MODULE_2__["BuildingAddressModel"]();
        this.portegoService.getBuildingAdress(this.idBuilding).subscribe(data => {
            this.model = data;
        });
    }
};
HouseNumberPlaqueComponent.ctorParameters = () => [
    { type: src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_3__["PortegoService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], HouseNumberPlaqueComponent.prototype, "idBuilding", void 0);
HouseNumberPlaqueComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-house-number-plaque',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./house-number-plaque.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/house-number-plaque/house-number-plaque.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./house-number-plaque.component.less */ "./src/app/components/house-number-plaque/house-number-plaque.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_3__["PortegoService"]])
], HouseNumberPlaqueComponent);



/***/ }),

/***/ "./src/app/components/kiosk-modal/kiosk-modal.component.less":
/*!*******************************************************************!*\
  !*** ./src/app/components/kiosk-modal/kiosk-modal.component.less ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".phone-modal {\n  font-family: Montserrat;\n  --phone-margin: 4.5rem;\n}\n@media only screen and (min-width: 1921px) {\n  .phone-modal {\n    --phone-margin: 8rem;\n  }\n}\n.phone-modal app-kiosk-modal {\n  display: flex;\n  flex-direction: column;\n}\n.phone-modal app-kiosk-modal .modal-header {\n  border-bottom: 0;\n  height: 5vh;\n  min-height: 150px;\n}\n.phone-modal app-kiosk-modal .modal-header .btn-close {\n  opacity: 1;\n  font-size: 5em;\n}\n.phone-modal app-kiosk-modal .modal-body {\n  -webkit-padding-after: 0;\n          padding-block-end: 0;\n  padding-inline: 4vw;\n  display: flex;\n  flex-direction: column;\n}\n.phone-modal app-kiosk-modal .modal-body .modal-heading {\n  font-size: 65pt;\n  line-height: 62pt;\n  color: #00A0E1;\n  font-weight: bolder;\n}\n@media only screen and (max-width: 1920px) {\n  .phone-modal app-kiosk-modal .modal-body .modal-heading {\n    font-size: 40pt;\n    line-height: 42pt;\n  }\n}\n.phone-modal app-kiosk-modal .modal-body .modal-message {\n  color: #8B8B8B;\n  flex: 0 0;\n  font-size: 40pt;\n  line-height: 48pt;\n  font-weight: bold;\n}\n@media only screen and (max-width: 1920px) {\n  .phone-modal app-kiosk-modal .modal-body .modal-message {\n    font-size: 32pt;\n    line-height: 35pt;\n  }\n}\n.phone-modal app-kiosk-modal .modal-body .links-to {\n  color: #8B8B8B;\n  font-size: 24pt;\n  font-weight: bold;\n}\n@media only screen and (max-width: 1920px) {\n  .phone-modal app-kiosk-modal .modal-body .links-to {\n    font-size: 18pt;\n  }\n}\n.phone-modal app-kiosk-modal .modal-body .links-to .link {\n  color: #00A0E1;\n  font-weight: bolder;\n  word-break: break-all;\n}\n.phone-modal app-kiosk-modal .modal-body .phone-container {\n  --background-width: 100%;\n  background-image: url('/assets/images/iphone_cropped_vertical@2x.png');\n  background-size: 100% var(--background-width);\n  background-repeat: no-repeat;\n  background-position-x: 1.5em;\n  margin-top: 30px;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 25%;\n  max-height: 1000px;\n  min-height: 700px;\n}\n@media only screen and (max-height: 1080px) {\n  .phone-modal app-kiosk-modal .modal-body .phone-container {\n    --background-width: 120%;\n  }\n}\n.phone-modal app-kiosk-modal .modal-body .phone-container .qr-code {\n  margin-right: var(--phone-margin);\n}\n.phone-modal app-kiosk-modal .modal-body .phone-container .qr-code img {\n  width: 300px;\n}\n@media only screen and (max-width: 1080px) {\n  .phone-modal app-kiosk-modal .modal-body .phone-container .qr-code img {\n    width: 250px;\n  }\n}\n@media only screen and (max-width: 780px) {\n  .phone-modal app-kiosk-modal .modal-body .phone-container .qr-code img {\n    width: 150px;\n  }\n}\n.phone-modal app-kiosk-modal .modal-body .phone-container .scan-me {\n  margin-right: var(--phone-margin);\n  margin-bottom: 2vh;\n  background-color: #00A0E1;\n  color: white;\n  height: 100px;\n  width: 300px;\n  font-weight: bold;\n  font-size: 24pt;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n@media only screen and (max-width: 1920px) {\n  .phone-modal app-kiosk-modal .modal-body .phone-container .scan-me {\n    width: 125px;\n    height: 50px;\n    font-size: 16pt;\n    font-weight: normal;\n  }\n}\n.phone-modal app-kiosk-modal {\n  border-radius: 1vw;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  min-height: 1080px;\n  flex-shrink: 1;\n  max-height: 2000px;\n}\n.phone-modal app-kiosk-modal .modal-content {\n  border-radius: 1vw;\n}\n.phone-modal app-kiosk-modal .modal-body {\n  padding-bottom: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/kiosk-modal/kiosk-modal.component.ts":
/*!*****************************************************************!*\
  !*** ./src/app/components/kiosk-modal/kiosk-modal.component.ts ***!
  \*****************************************************************/
/*! exports provided: KioskModalComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KioskModalComponent", function() { return KioskModalComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");




let KioskModalComponent = class KioskModalComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
    ngOnInit() {
        // GAT 12 requirement: Close modal after 20s
        Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["timer"])(20000).subscribe(() => this.activeModal.close());
    }
};
KioskModalComponent.ctorParameters = () => [
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], KioskModalComponent.prototype, "url", void 0);
KioskModalComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-kiosk-modal',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./kiosk-modal.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/kiosk-modal/kiosk-modal.component.html")).default,
        encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./kiosk-modal.component.less */ "./src/app/components/kiosk-modal/kiosk-modal.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"]])
], KioskModalComponent);



/***/ }),

/***/ "./src/app/components/links-tile/links-tile.component.less":
/*!*****************************************************************!*\
  !*** ./src/app/components/links-tile/links-tile.component.less ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".link-tile {\n  line-height: 1em;\n}\n.link-tile img {\n  height: 62px;\n  padding-bottom: 8px;\n}\n.link-tile a {\n  white-space: pre-wrap;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50cy9saW5rcy10aWxlL0M6L19kZXYvU291cmNlL1JlcG9zL1NjaHdhcnplc0JyZXR0LkluZm9ib2FyZHNXZWIvaW5mb2JvYXJkc3dlYi1hcHAvc3JjL2FwcC9jb21wb25lbnRzL2xpbmtzLXRpbGUvbGlua3MtdGlsZS5jb21wb25lbnQubGVzcyIsInNyYy9hcHAvY29tcG9uZW50cy9saW5rcy10aWxlL2xpbmtzLXRpbGUuY29tcG9uZW50Lmxlc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFNRSxnQkFBQTtBQ0pGO0FERkE7RUFFSSxZQUFBO0VBQ0EsbUJBQUE7QUNHSjtBRE5BO0VBU0kscUJBQUE7QUNBSiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvbGlua3MtdGlsZS9saW5rcy10aWxlLmNvbXBvbmVudC5sZXNzIiwic291cmNlc0NvbnRlbnQiOlsiLmxpbmstdGlsZSB7XG4gIGltZyB7XG4gICAgaGVpZ2h0OiA2MnB4O1xuICAgIHBhZGRpbmctYm90dG9tOiA4cHg7XG4gIH1cblxuICBsaW5lLWhlaWdodDogMWVtO1xuXG4gIGEge1xuICAgIHdoaXRlLXNwYWNlOiBwcmUtd3JhcDtcbiAgfVxufSIsIi5saW5rLXRpbGUge1xuICBsaW5lLWhlaWdodDogMWVtO1xufVxuLmxpbmstdGlsZSBpbWcge1xuICBoZWlnaHQ6IDYycHg7XG4gIHBhZGRpbmctYm90dG9tOiA4cHg7XG59XG4ubGluay10aWxlIGEge1xuICB3aGl0ZS1zcGFjZTogcHJlLXdyYXA7XG59XG4iXX0= */");

/***/ }),

/***/ "./src/app/components/links-tile/links-tile.component.ts":
/*!***************************************************************!*\
  !*** ./src/app/components/links-tile/links-tile.component.ts ***!
  \***************************************************************/
/*! exports provided: LinksTileComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LinksTileComponent", function() { return LinksTileComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");



let LinksTileComponent = class LinksTileComponent {
    constructor() {
    }
    ngOnInit() {
        this.links = src_environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].links;
    }
};
LinksTileComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-links-tile',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./links-tile.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/links-tile/links-tile.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./links-tile.component.less */ "./src/app/components/links-tile/links-tile.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], LinksTileComponent);



/***/ }),

/***/ "./src/app/components/no-data/no-data.component.less":
/*!***********************************************************!*\
  !*** ./src/app/components/no-data/no-data.component.less ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".no-data {\n  position: relative;\n  height: 100%;\n}\n.no-data > .text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-transform: uppercase;\n  text-align: center;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50cy9uby1kYXRhL0M6L19kZXYvU291cmNlL1JlcG9zL1NjaHdhcnplc0JyZXR0LkluZm9ib2FyZHNXZWIvaW5mb2JvYXJkc3dlYi1hcHAvc3JjL2FwcC9jb21wb25lbnRzL25vLWRhdGEvbm8tZGF0YS5jb21wb25lbnQubGVzcyIsInNyYy9hcHAvY29tcG9uZW50cy9uby1kYXRhL25vLWRhdGEuY29tcG9uZW50Lmxlc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxrQkFBQTtFQUNBLFlBQUE7QUNDRjtBREhBO0VBSUksa0JBQUE7RUFDQSxRQUFBO0VBQ0EsU0FBQTtFQUNBLGdDQUFBO0VBQ0EseUJBQUE7RUFDQSxrQkFBQTtBQ0VKIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50cy9uby1kYXRhL25vLWRhdGEuY29tcG9uZW50Lmxlc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubm8tZGF0YSB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgaGVpZ2h0OiAxMDAlO1xuICA+IC50ZXh0IHtcbiAgICBwb3NpdGlvbiAgICAgIDogYWJzb2x1dGU7XG4gICAgdG9wICAgICAgICAgICA6IDUwJTtcbiAgICBsZWZ0ICAgICAgICAgIDogNTAlO1xuICAgIHRyYW5zZm9ybSAgICAgOiB0cmFuc2xhdGUoLTUwJSwgLTUwJSk7XG4gICAgdGV4dC10cmFuc2Zvcm06IHVwcGVyY2FzZTtcbiAgICB0ZXh0LWFsaWduICAgIDogY2VudGVyO1xuICB9XG59XG4iLCIubm8tZGF0YSB7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuLm5vLWRhdGEgPiAudGV4dCB7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiA1MCU7XG4gIGxlZnQ6IDUwJTtcbiAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoLTUwJSwgLTUwJSk7XG4gIHRleHQtdHJhbnNmb3JtOiB1cHBlcmNhc2U7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbn1cbiJdfQ== */");

/***/ }),

/***/ "./src/app/components/no-data/no-data.component.ts":
/*!*********************************************************!*\
  !*** ./src/app/components/no-data/no-data.component.ts ***!
  \*********************************************************/
/*! exports provided: NoDataComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NoDataComponent", function() { return NoDataComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let NoDataComponent = class NoDataComponent {
    constructor() { }
    ngOnInit() {
    }
};
NoDataComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-no-data',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./no-data.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/no-data/no-data.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./no-data.component.less */ "./src/app/components/no-data/no-data.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], NoDataComponent);



/***/ }),

/***/ "./src/app/components/privacy-banner/privacy-banner.component.less":
/*!*************************************************************************!*\
  !*** ./src/app/components/privacy-banner/privacy-banner.component.less ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvcHJpdmFjeS1iYW5uZXIvcHJpdmFjeS1iYW5uZXIuY29tcG9uZW50Lmxlc3MifQ== */");

/***/ }),

/***/ "./src/app/components/privacy-banner/privacy-banner.component.ts":
/*!***********************************************************************!*\
  !*** ./src/app/components/privacy-banner/privacy-banner.component.ts ***!
  \***********************************************************************/
/*! exports provided: PrivacyBannerComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PrivacyBannerComponent", function() { return PrivacyBannerComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! util */ "./node_modules/util/util.js");
/* harmony import */ var util__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(util__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");




let PrivacyBannerComponent = class PrivacyBannerComponent {
    constructor(router) {
        this.router = router;
    }
    ngOnInit() {
        const privacy = localStorage.getItem('privacy-banner-key');
        this.isEnabled = Object(util__WEBPACK_IMPORTED_MODULE_2__["isNullOrUndefined"])(privacy);
    }
    closeClicked() {
        localStorage['privacy-banner-key'] = false;
    }
    privacyPolicyClicked() {
        this.router.navigate(['/privacy-policy']);
        return false;
    }
};
PrivacyBannerComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] }
];
PrivacyBannerComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-privacy-banner',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./privacy-banner.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/privacy-banner/privacy-banner.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./privacy-banner.component.less */ "./src/app/components/privacy-banner/privacy-banner.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"]])
], PrivacyBannerComponent);



/***/ }),

/***/ "./src/app/components/privacy-policy/privacy-policy.component.less":
/*!*************************************************************************!*\
  !*** ./src/app/components/privacy-policy/privacy-policy.component.less ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvcHJpdmFjeS1wb2xpY3kvcHJpdmFjeS1wb2xpY3kuY29tcG9uZW50Lmxlc3MifQ== */");

/***/ }),

/***/ "./src/app/components/privacy-policy/privacy-policy.component.ts":
/*!***********************************************************************!*\
  !*** ./src/app/components/privacy-policy/privacy-policy.component.ts ***!
  \***********************************************************************/
/*! exports provided: PrivacyPolicyComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PrivacyPolicyComponent", function() { return PrivacyPolicyComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let PrivacyPolicyComponent = class PrivacyPolicyComponent {
    constructor() { }
    ngOnInit() {
    }
};
PrivacyPolicyComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-privacy-policy',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./privacy-policy.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/privacy-policy/privacy-policy.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./privacy-policy.component.less */ "./src/app/components/privacy-policy/privacy-policy.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], PrivacyPolicyComponent);



/***/ }),

/***/ "./src/app/components/qrcode-tile/qrcode-tile.component.less":
/*!*******************************************************************!*\
  !*** ./src/app/components/qrcode-tile/qrcode-tile.component.less ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("app-qrcode-tile .tile {\n  background: #00A0E1;\n}\napp-qrcode-tile .centered {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\napp-qrcode-tile qrcode {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 0.5em;\n}\napp-qrcode-tile qrcode img {\n  width: 150px;\n}\napp-qrcode-tile .inner a {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvY29tcG9uZW50cy9xcmNvZGUtdGlsZS9DOi9fZGV2L1NvdXJjZS9SZXBvcy9TY2h3YXJ6ZXNCcmV0dC5JbmZvYm9hcmRzV2ViL2luZm9ib2FyZHN3ZWItYXBwL3NyYy9hcHAvY29tcG9uZW50cy9xcmNvZGUtdGlsZS9xcmNvZGUtdGlsZS5jb21wb25lbnQubGVzcyIsInNyYy9hcHAvY29tcG9uZW50cy9xcmNvZGUtdGlsZS9xcmNvZGUtdGlsZS5jb21wb25lbnQubGVzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQTtFQUVJLG1CQUFBO0FDRko7QURBQTtFQU1JLGFBQUE7RUFDQSxtQkFBQTtFQUNBLHVCQUFBO0VBQ0EsbUJBQUE7QUNISjtBRE5BO0VBTUksYUFBQTtFQUNBLG1CQUFBO0VBQ0EsdUJBQUE7RUFDQSxtQkFBQTtFQUtBLG9CQUFBO0FDREo7QURiQTtFQWlCTSxZQUFBO0FDRE47QURoQkE7RUFNSSxhQUFBO0VBQ0EsbUJBQUE7RUFDQSx1QkFBQTtFQUNBLG1CQUFBO0FDYUoiLCJmaWxlIjoic3JjL2FwcC9jb21wb25lbnRzL3FyY29kZS10aWxlL3FyY29kZS10aWxlLmNvbXBvbmVudC5sZXNzIiwic291cmNlc0NvbnRlbnQiOlsiQGltcG9ydCAocmVmZXJlbmNlKSBcIi4uLy4uLy4uL3N0eWxlcy9icmFuZC1jb2wubGVzc1wiO1xuXG5hcHAtcXJjb2RlLXRpbGUge1xuICAudGlsZSB7XG4gICAgYmFja2dyb3VuZDogQGJyYW5kLWNvbDtcbiAgfVxuXG4gIC5jZW50ZXJlZCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICAgIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIH1cblxuICBxcmNvZGUge1xuICAgIC5jZW50ZXJlZCgpO1xuICAgIG1hcmdpbi1ib3R0b206IDAuNWVtO1xuXG4gICAgaW1nIHtcbiAgICAgIHdpZHRoOiAxNTBweDtcbiAgICB9XG4gIH1cblxuICAuaW5uZXIgYSB7XG4gICAgLmNlbnRlcmVkKClcbiAgfVxufVxuIiwiYXBwLXFyY29kZS10aWxlIC50aWxlIHtcbiAgYmFja2dyb3VuZDogIzAwQTBFMTtcbn1cbmFwcC1xcmNvZGUtdGlsZSAuY2VudGVyZWQge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbn1cbmFwcC1xcmNvZGUtdGlsZSBxcmNvZGUge1xuICBkaXNwbGF5OiBmbGV4O1xuICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgbWFyZ2luLWJvdHRvbTogMC41ZW07XG59XG5hcHAtcXJjb2RlLXRpbGUgcXJjb2RlIGltZyB7XG4gIHdpZHRoOiAxNTBweDtcbn1cbmFwcC1xcmNvZGUtdGlsZSAuaW5uZXIgYSB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiByb3c7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xufVxuIl19 */");

/***/ }),

/***/ "./src/app/components/qrcode-tile/qrcode-tile.component.ts":
/*!*****************************************************************!*\
  !*** ./src/app/components/qrcode-tile/qrcode-tile.component.ts ***!
  \*****************************************************************/
/*! exports provided: QrcodeTileComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QrcodeTileComponent", function() { return QrcodeTileComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let QrcodeTileComponent = class QrcodeTileComponent {
    constructor() { }
    ngOnInit() {
        if (typeof this.url === 'undefined') {
            this.url = location.href;
        }
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], QrcodeTileComponent.prototype, "url", void 0);
QrcodeTileComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-qrcode-tile',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./qrcode-tile.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/qrcode-tile/qrcode-tile.component.html")).default,
        encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./qrcode-tile.component.less */ "./src/app/components/qrcode-tile/qrcode-tile.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], QrcodeTileComponent);



/***/ }),

/***/ "./src/app/components/scroll-to-top/scroll-to-top.component.less":
/*!***********************************************************************!*\
  !*** ./src/app/components/scroll-to-top/scroll-to-top.component.less ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".scroll-to-top {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  background: rgba(153, 153, 153, 0.9);\n  border-radius: 4px;\n  color: #FFF;\n  padding: 1em 1.3em 0.9em;\n  cursor: pointer;\n  opacity: 0;\n  z-index: 666;\n  transition: all 0.2s ease-in-out;\n}\n.scroll-to-top i {\n  border: solid #fff;\n  border-width: 0 6px 6px 0;\n  display: inline-block;\n  padding: 3px;\n}\n.scroll-to-top i.up {\n  transform: rotate(-135deg);\n  -webkit-transform: rotate(-135deg);\n}\n.show-scrollTop {\n  opacity: 1;\n  transition: all 0.2s ease-in-out;\n}\n\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/scroll-to-top/scroll-to-top.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/components/scroll-to-top/scroll-to-top.component.ts ***!
  \*********************************************************************/
/*! exports provided: ScrollToTopComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollToTopComponent", function() { return ScrollToTopComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


// https://medium.com/@appl4e/scroll-to-top-button-for-angular-99ddeebb8c3a <3
let ScrollToTopComponent = class ScrollToTopComponent {
    constructor() { }
    ngOnInit() {
    }
    onWindowScroll() {
        if (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 100) {
            this.windowScrolled = true;
        }
        else if (this.windowScrolled && window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop < 10) {
            this.windowScrolled = false;
        }
    }
    scrollToTop() {
        (function smoothscroll() {
            const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
            if (currentScroll > 0) {
                window.requestAnimationFrame(smoothscroll);
                window.scrollTo(0, currentScroll - (currentScroll / 8));
            }
        })();
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])('window:scroll', []),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Function),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", []),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:returntype", void 0)
], ScrollToTopComponent.prototype, "onWindowScroll", null);
ScrollToTopComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-scroll-to-top',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./scroll-to-top.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/scroll-to-top/scroll-to-top.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./scroll-to-top.component.less */ "./src/app/components/scroll-to-top/scroll-to-top.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], ScrollToTopComponent);



/***/ }),

/***/ "./src/app/components/subscribe-tile/subscribe-tile.component.less":
/*!*************************************************************************!*\
  !*** ./src/app/components/subscribe-tile/subscribe-tile.component.less ***!
  \*************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvc3Vic2NyaWJlLXRpbGUvc3Vic2NyaWJlLXRpbGUuY29tcG9uZW50Lmxlc3MifQ== */");

/***/ }),

/***/ "./src/app/components/subscribe-tile/subscribe-tile.component.ts":
/*!***********************************************************************!*\
  !*** ./src/app/components/subscribe-tile/subscribe-tile.component.ts ***!
  \***********************************************************************/
/*! exports provided: SubscribeTileComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubscribeTileComponent", function() { return SubscribeTileComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/portego.service */ "./src/app/services/portego.service.ts");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");





let SubscribeTileComponent = class SubscribeTileComponent {
    constructor(portegoService) {
        this.portegoService = portegoService;
        this.model = { email: null, acceptPrivacyPolicy: false };
    }
    ngOnInit() {
        this.complete = false;
        this.error = false;
    }
    onSubmit(form) {
        if (form.valid !== true) {
            return;
        }
        this.portegoService.createSubscription(this.model.email, this.idBuilding, null).subscribe(() => {
            this.complete = true;
            this.resetFormAfterMilliseconds(10000);
        }, (error) => {
            console.log(error);
            this.resetFormAfterMilliseconds(10000);
            this.error = true;
            if (error.status === 409 /* Error Code: Conflict */) {
                this.errorMessage = error.statusText;
            }
        });
    }
    resetFormAfterMilliseconds(msec = 10000) {
        Object(rxjs__WEBPACK_IMPORTED_MODULE_4__["timer"])(msec).subscribe(() => {
            this.ngOnInit();
            this.subscribeForm.resetForm();
        });
    }
};
SubscribeTileComponent.ctorParameters = () => [
    { type: src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_3__["PortegoService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], SubscribeTileComponent.prototype, "idBuilding", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])('subscribeForm', { static: false }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", _angular_forms__WEBPACK_IMPORTED_MODULE_2__["NgForm"])
], SubscribeTileComponent.prototype, "subscribeForm", void 0);
SubscribeTileComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-subscribe-tile',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./subscribe-tile.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/subscribe-tile/subscribe-tile.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./subscribe-tile.component.less */ "./src/app/components/subscribe-tile/subscribe-tile.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_3__["PortegoService"]])
], SubscribeTileComponent);



/***/ }),

/***/ "./src/app/components/tile/tile.component.less":
/*!*****************************************************!*\
  !*** ./src/app/components/tile/tile.component.less ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvdGlsZS90aWxlLmNvbXBvbmVudC5sZXNzIn0= */");

/***/ }),

/***/ "./src/app/components/tile/tile.component.ts":
/*!***************************************************!*\
  !*** ./src/app/components/tile/tile.component.ts ***!
  \***************************************************/
/*! exports provided: TileComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TileComponent", function() { return TileComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_models_slideInfo_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/models/slideInfo-model */ "./src/app/models/slideInfo-model.ts");



let TileComponent = class TileComponent {
    constructor() { }
    ngOnInit() {
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", String)
], TileComponent.prototype, "headline", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Number)
], TileComponent.prototype, "idBuilding", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", src_app_models_slideInfo_model__WEBPACK_IMPORTED_MODULE_2__["SlideInfoModel"])
], TileComponent.prototype, "slideInfo", void 0);
TileComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-tile',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./tile.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/tile/tile.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./tile.component.less */ "./src/app/components/tile/tile.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], TileComponent);



/***/ }),

/***/ "./src/app/components/topic-list-tile/topic-list-tile.component.less":
/*!***************************************************************************!*\
  !*** ./src/app/components/topic-list-tile/topic-list-tile.component.less ***!
  \***************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvdG9waWMtbGlzdC10aWxlL3RvcGljLWxpc3QtdGlsZS5jb21wb25lbnQubGVzcyJ9 */");

/***/ }),

/***/ "./src/app/components/topic-list-tile/topic-list-tile.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/components/topic-list-tile/topic-list-tile.component.ts ***!
  \*************************************************************************/
/*! exports provided: TopicListTileComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TopicListTileComponent", function() { return TopicListTileComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let TopicListTileComponent = class TopicListTileComponent {
    constructor() {
        this.moreClick = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
    }
    ngOnInit() {
    }
    moreClicked(slideId) {
        this.moreClick.emit(slideId);
    }
};
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Array)
], TopicListTileComponent.prototype, "models", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], TopicListTileComponent.prototype, "moreClick", void 0);
TopicListTileComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-topic-list-tile',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./topic-list-tile.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/topic-list-tile/topic-list-tile.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./topic-list-tile.component.less */ "./src/app/components/topic-list-tile/topic-list-tile.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], TopicListTileComponent);



/***/ }),

/***/ "./src/app/components/topic-tile/topic-tile.component.less":
/*!*****************************************************************!*\
  !*** ./src/app/components/topic-tile/topic-tile.component.less ***!
  \*****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvdG9waWMtdGlsZS90b3BpYy10aWxlLmNvbXBvbmVudC5sZXNzIn0= */");

/***/ }),

/***/ "./src/app/components/topic-tile/topic-tile.component.ts":
/*!***************************************************************!*\
  !*** ./src/app/components/topic-tile/topic-tile.component.ts ***!
  \***************************************************************/
/*! exports provided: TopicTileComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TopicTileComponent", function() { return TopicTileComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_models_announcements_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/models/announcements-model */ "./src/app/models/announcements-model.ts");
/* harmony import */ var src_app_services_download_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/download.service */ "./src/app/services/download.service.ts");
/* harmony import */ var src_app_services_kiosk_mode_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/services/kiosk-mode.service */ "./src/app/services/kiosk-mode.service.ts");





let TopicTileComponent = class TopicTileComponent {
    constructor(downloadService, kioskModeService) {
        this.downloadService = downloadService;
        this.kioskModeService = kioskModeService;
        this.backClick = new _angular_core__WEBPACK_IMPORTED_MODULE_1__["EventEmitter"]();
    }
    ngOnInit() {
    }
    onClick(event) {
        if (!this.kioskModeService.isKioskMode) {
            // When not in kiosk mode, do everything as normal. Don't intercept click
            return true;
        }
        if (event.target.tagName === 'A' && event.target.href
            && this.isExternalHref(event.target.href)) {
            this.kioskModeService.openModal(event.target.href);
        }
        // returning false here is equal to event.preventDefault()
        return false;
    }
    downloadAttachment() {
        this.downloadService.downloadFile(this.model.attachment);
        return false;
    }
    backClicked() {
        this.backClick.emit(null);
    }
    getRootUrl() {
        return window.location.origin
            ? window.location.origin + '/'
            : window.location.protocol + '/' + window.location.host + '/';
    }
    isExternalHref(href) {
        return href != this.getRootUrl();
    }
};
TopicTileComponent.ctorParameters = () => [
    { type: src_app_services_download_service__WEBPACK_IMPORTED_MODULE_3__["DownloadService"] },
    { type: src_app_services_kiosk_mode_service__WEBPACK_IMPORTED_MODULE_4__["KioskModeService"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Input"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", src_app_models_announcements_model__WEBPACK_IMPORTED_MODULE_2__["AnnouncementsModel"])
], TopicTileComponent.prototype, "model", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Output"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Object)
], TopicTileComponent.prototype, "backClick", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["HostListener"])('click', ['$event']),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:type", Function),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [Object]),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:returntype", void 0)
], TopicTileComponent.prototype, "onClick", null);
TopicTileComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-topic-tile',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./topic-tile.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/topic-tile/topic-tile.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./topic-tile.component.less */ "./src/app/components/topic-tile/topic-tile.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [src_app_services_download_service__WEBPACK_IMPORTED_MODULE_3__["DownloadService"],
        src_app_services_kiosk_mode_service__WEBPACK_IMPORTED_MODULE_4__["KioskModeService"]])
], TopicTileComponent);



/***/ }),

/***/ "./src/app/handler/global-error.handler.ts":
/*!*************************************************!*\
  !*** ./src/app/handler/global-error.handler.ts ***!
  \*************************************************/
/*! exports provided: GlobalErrorHandler */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalErrorHandler", function() { return GlobalErrorHandler; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let GlobalErrorHandler = class GlobalErrorHandler {
    constructor() { }
    handleError(error) {
        if ('message' in error)
            console.error(`Error: ${error.message}`, error);
        else
            console.error('Undefined Error: ', error);
    }
};
GlobalErrorHandler = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])(),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], GlobalErrorHandler);



/***/ }),

/***/ "./src/app/helper/datetime.ts":
/*!************************************!*\
  !*** ./src/app/helper/datetime.ts ***!
  \************************************/
/*! exports provided: DateTime */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DateTime", function() { return DateTime; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class DateTime {
    constructor() {
        this.monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli',
            'August', 'September', 'Oktober', 'November', 'Dezember'];
        this.days = [
            'Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'
        ];
    }
    getFormattedDate(date) {
        return date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
    }
    getCurrentDate() {
        const today = new Date();
        const day = today.getDate();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        let formattedDay = day.toString();
        if (day < 10) {
            formattedDay = `0${day}`;
        }
        const date = `${this.days[today.getDay()]}, ${formattedDay}. ${this.monthNames[month - 1]} ${year}`;
        return date;
    }
    getCurrentWeekNumber() {
        const date = new Date();
        const thisDay = date.getDate();
        const newDate = date;
        newDate.setDate(1);
        const digit = newDate.getDay();
        const q = (thisDay + digit) / 7;
        const r = (thisDay + digit) % 7;
        if (r !== 0) {
            return Math.ceil(q);
        }
        else {
            return q;
        }
    }
}


/***/ }),

/***/ "./src/app/helper/openWeatherMap.ts":
/*!******************************************!*\
  !*** ./src/app/helper/openWeatherMap.ts ***!
  \******************************************/
/*! exports provided: OpenWeatherMap */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OpenWeatherMap", function() { return OpenWeatherMap; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_configuration_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/configuration.service */ "./src/configuration.service.ts");




let OpenWeatherMap = class OpenWeatherMap {
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this.forecastDays = 1;
        this.appId = config.getOpenWeatherMapApiKey();
        this.serviceUrl = 'https://api.openweathermap.org/data/2.5';
        this.serviceParams = 'units=metric&lang=de';
    }
    getData(city) {
        return Promise.all([this.getCurrentTemperature(city) /*, this.getForecastForToday(city)*/]);
    }
    getCurrentTemperature(city) {
        const url = `${this.serviceUrl}/weather?q=${city}&APPID=${this.appId}&${this.serviceParams}`;
        return this.http.get(url).toPromise();
    }
    getForecastForToday(city) {
        const url = `${this.serviceUrl}/forecast/daily?q=${city}&cnt=${this.forecastDays}&APPID=${this.appId}&${this.serviceParams}`;
        return this.http.get(url).toPromise();
    }
    getIconPath(id) {
        switch (id) {
            case 800:
                return 'wi-day-sunny';
            case 200:
            case 201:
            case 202:
            case 210:
            case 211:
            case 221:
            case 230:
            case 231:
            case 232:
                return 'wi-strong-wind';
            case 300:
            case 301:
            case 302:
            case 310:
            case 311:
            case 312:
            case 313:
            case 314:
            case 321:
                return 'wi-rain';
            case 500:
            case 501:
            case 502:
            case 503:
            case 504:
            case 511:
            case 520:
            case 521:
            case 522:
            case 531:
                return 'wi-showers';
            case 600:
            case 601:
            case 602:
            case 611:
            case 612:
            case 615:
            case 616:
            case 620:
            case 621:
            case 622:
                return 'wi-snow';
            case 802:
            case 803:
            case 804:
            case 701:
            case 711:
            case 721:
            case 731:
            case 741:
            case 751:
            case 761:
            case 762:
            case 771:
            case 781:
                return 'wi-cloudy';
            default:
                return 'wi-day-sunny';
        }
    }
};
OpenWeatherMap.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: src_configuration_service__WEBPACK_IMPORTED_MODULE_3__["default"] }
];
OpenWeatherMap = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"], src_configuration_service__WEBPACK_IMPORTED_MODULE_3__["default"]])
], OpenWeatherMap);



/***/ }),

/***/ "./src/app/models/announcements-model.ts":
/*!***********************************************!*\
  !*** ./src/app/models/announcements-model.ts ***!
  \***********************************************/
/*! exports provided: AnnouncementsModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnnouncementsModel", function() { return AnnouncementsModel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class AnnouncementsModel {
}


/***/ }),

/***/ "./src/app/models/appointment-model.ts":
/*!*********************************************!*\
  !*** ./src/app/models/appointment-model.ts ***!
  \*********************************************/
/*! exports provided: AppointmentModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppointmentModel", function() { return AppointmentModel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class AppointmentModel {
}


/***/ }),

/***/ "./src/app/models/building-address-model.ts":
/*!**************************************************!*\
  !*** ./src/app/models/building-address-model.ts ***!
  \**************************************************/
/*! exports provided: BuildingAddressModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BuildingAddressModel", function() { return BuildingAddressModel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class BuildingAddressModel {
    constructor() { }
}


/***/ }),

/***/ "./src/app/models/contacts/contact-model.ts":
/*!**************************************************!*\
  !*** ./src/app/models/contacts/contact-model.ts ***!
  \**************************************************/
/*! exports provided: ContactModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContactModel", function() { return ContactModel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class ContactModel {
    constructor() {
    }
}


/***/ }),

/***/ "./src/app/models/e-contact-type.enum.ts":
/*!***********************************************!*\
  !*** ./src/app/models/e-contact-type.enum.ts ***!
  \***********************************************/
/*! exports provided: EContactType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EContactType", function() { return EContactType; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

var EContactType;
(function (EContactType) {
    EContactType[EContactType["Contact"] = 1] = "Contact";
    EContactType[EContactType["EmergencyContact"] = 2] = "EmergencyContact";
})(EContactType || (EContactType = {}));


/***/ }),

/***/ "./src/app/models/eannouncement-type.enum.ts":
/*!***************************************************!*\
  !*** ./src/app/models/eannouncement-type.enum.ts ***!
  \***************************************************/
/*! exports provided: EAnnouncementType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EAnnouncementType", function() { return EAnnouncementType; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

var EAnnouncementType;
(function (EAnnouncementType) {
    EAnnouncementType[EAnnouncementType["information"] = 1] = "information";
    EAnnouncementType[EAnnouncementType["warning"] = 2] = "warning";
    EAnnouncementType[EAnnouncementType["livingTogether"] = 3] = "livingTogether";
    EAnnouncementType[EAnnouncementType["parkingUnit"] = 4] = "parkingUnit";
    EAnnouncementType[EAnnouncementType["waste"] = 5] = "waste";
    EAnnouncementType[EAnnouncementType["safety"] = 6] = "safety";
    EAnnouncementType[EAnnouncementType["hint"] = 7] = "hint";
    EAnnouncementType[EAnnouncementType["topicOfTheMonth"] = 8] = "topicOfTheMonth";
})(EAnnouncementType || (EAnnouncementType = {}));


/***/ }),

/***/ "./src/app/models/slideInfo-model.ts":
/*!*******************************************!*\
  !*** ./src/app/models/slideInfo-model.ts ***!
  \*******************************************/
/*! exports provided: SlideInfoModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SlideInfoModel", function() { return SlideInfoModel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class SlideInfoModel {
}


/***/ }),

/***/ "./src/app/models/weather/temperature-model.ts":
/*!*****************************************************!*\
  !*** ./src/app/models/weather/temperature-model.ts ***!
  \*****************************************************/
/*! exports provided: TemperatureModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TemperatureModel", function() { return TemperatureModel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class TemperatureModel {
    constructor() {
    }
}


/***/ }),

/***/ "./src/app/models/weather/weather-model.ts":
/*!*************************************************!*\
  !*** ./src/app/models/weather/weather-model.ts ***!
  \*************************************************/
/*! exports provided: WeatherModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WeatherModel", function() { return WeatherModel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

class WeatherModel {
    constructor() {
    }
}


/***/ }),

/***/ "./src/app/models/weather/weather-of-the-day-model.ts":
/*!************************************************************!*\
  !*** ./src/app/models/weather/weather-of-the-day-model.ts ***!
  \************************************************************/
/*! exports provided: WeatherOfTheDayModel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WeatherOfTheDayModel", function() { return WeatherOfTheDayModel; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _temperature_model__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./temperature-model */ "./src/app/models/weather/temperature-model.ts");
/* harmony import */ var _weather_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./weather-model */ "./src/app/models/weather/weather-model.ts");



class WeatherOfTheDayModel {
    constructor() {
        this.temp = new _temperature_model__WEBPACK_IMPORTED_MODULE_1__["TemperatureModel"]();
        this.weather = new _weather_model__WEBPACK_IMPORTED_MODULE_2__["WeatherModel"]();
    }
}


/***/ }),

/***/ "./src/app/services/anouncement-icon.service.ts":
/*!******************************************************!*\
  !*** ./src/app/services/anouncement-icon.service.ts ***!
  \******************************************************/
/*! exports provided: AnouncementIconService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnouncementIconService", function() { return AnouncementIconService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _models_eannouncement_type_enum__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../models/eannouncement-type.enum */ "./src/app/models/eannouncement-type.enum.ts");



let AnouncementIconService = class AnouncementIconService {
    constructor() {
        this.iconPath = '../../assets/images/newsicons/';
    }
    getIconPath(enumType) {
        switch (enumType) {
            case _models_eannouncement_type_enum__WEBPACK_IMPORTED_MODULE_2__["EAnnouncementType"].information:
                return this.iconPath + 'information.png';
            case _models_eannouncement_type_enum__WEBPACK_IMPORTED_MODULE_2__["EAnnouncementType"].livingTogether:
                return this.iconPath + 'livingTogether.png';
            case _models_eannouncement_type_enum__WEBPACK_IMPORTED_MODULE_2__["EAnnouncementType"].waste:
                return this.iconPath + 'waste.png';
            case _models_eannouncement_type_enum__WEBPACK_IMPORTED_MODULE_2__["EAnnouncementType"].parkingUnit:
                return this.iconPath + 'parkingUnit.png';
            case _models_eannouncement_type_enum__WEBPACK_IMPORTED_MODULE_2__["EAnnouncementType"].warning:
                return this.iconPath + 'warning.png';
            case _models_eannouncement_type_enum__WEBPACK_IMPORTED_MODULE_2__["EAnnouncementType"].safety:
                return this.iconPath + 'safety.png';
            case _models_eannouncement_type_enum__WEBPACK_IMPORTED_MODULE_2__["EAnnouncementType"].hint:
                return this.iconPath + 'hint.png';
            case _models_eannouncement_type_enum__WEBPACK_IMPORTED_MODULE_2__["EAnnouncementType"].topicOfTheMonth:
                return this.iconPath + 'topicOfTheMonth.png';
            default:
                return this.iconPath + 'news_icon.png';
        }
    }
};
AnouncementIconService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], AnouncementIconService);



/***/ }),

/***/ "./src/app/services/appointment-icon.service.ts":
/*!******************************************************!*\
  !*** ./src/app/services/appointment-icon.service.ts ***!
  \******************************************************/
/*! exports provided: AppoinmentIconService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppoinmentIconService", function() { return AppoinmentIconService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let AppoinmentIconService = class AppoinmentIconService {
    constructor() {
        this.iconPath = '../../assets/images/appointmenticons/';
    }
    getIconPath(keycode) {
        switch (keycode) {
            case 'Information':
                return this.iconPath + 'Information.png';
            case 'CleaningUndergroundCarPark':
                return this.iconPath + 'CleaningUndergroundCarPark.png';
            case 'Cleaning':
                return this.iconPath + 'Cleaning.png';
            case 'ChimneySweep':
                return this.iconPath + 'ChimneySweep.png';
            case 'Garbage':
                return this.iconPath + 'Garbage.png';
            case 'PropertyInspection':
                return this.iconPath + 'PropertyInspection.png';
            case 'Reading':
                return this.iconPath + 'Reading.png';
            case 'Housemeeting':
                return this.iconPath + 'HouseMeeting.png';
            case 'Children':
                return this.iconPath + 'Children.png';
            case 'ImportantInformation':
                return this.iconPath + 'ImportantInformation.png';
            default:
                return this.iconPath + 'Information.png';
        }
    }
};
AppoinmentIconService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], AppoinmentIconService);



/***/ }),

/***/ "./src/app/services/download.service.ts":
/*!**********************************************!*\
  !*** ./src/app/services/download.service.ts ***!
  \**********************************************/
/*! exports provided: DownloadService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DownloadService", function() { return DownloadService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _kiosk_mode_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./kiosk-mode.service */ "./src/app/services/kiosk-mode.service.ts");



let DownloadService = class DownloadService {
    constructor(kioskModeService) {
        this.kioskModeService = kioskModeService;
    }
    downloadFile(model) {
        if (this.kioskModeService.isKioskMode) {
            this.kioskModeService.openModal(model.fileUrl);
            return;
        }
        fetch(model.fileUrl)
            .then(resp => resp.blob())
            .then(blob => {
            const localBlobUrl = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            document.body.appendChild(anchor);
            anchor.setAttribute('style', 'display: none');
            anchor.href = localBlobUrl;
            anchor.target = '_blank';
            anchor.download = model.name;
            anchor.click();
            window.URL.revokeObjectURL(localBlobUrl);
            document.body.removeChild(anchor);
        })
            .catch((error) => console.error(error));
    }
    convertBase64ToByteArray(value) {
        const raw = window.atob(value);
        const rawLength = raw.length;
        const array = new Uint8Array(new ArrayBuffer(rawLength));
        for (let i = 0; i < rawLength; i++) {
            array[i] = raw.charCodeAt(i);
        }
        return array;
    }
};
DownloadService.ctorParameters = () => [
    { type: _kiosk_mode_service__WEBPACK_IMPORTED_MODULE_2__["KioskModeService"] }
];
DownloadService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_kiosk_mode_service__WEBPACK_IMPORTED_MODULE_2__["KioskModeService"]])
], DownloadService);



/***/ }),

/***/ "./src/app/services/kiosk-mode.service.ts":
/*!************************************************!*\
  !*** ./src/app/services/kiosk-mode.service.ts ***!
  \************************************************/
/*! exports provided: KioskModeService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KioskModeService", function() { return KioskModeService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _components_kiosk_modal_kiosk_modal_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../components/kiosk-modal/kiosk-modal.component */ "./src/app/components/kiosk-modal/kiosk-modal.component.ts");




let KioskModeService = class KioskModeService {
    constructor(modalService) {
        this.modalService = modalService;
        this._isKioskMode = false;
        const storedIsKioskMode = localStorage.getItem('isKioskMode');
        if (storedIsKioskMode == null) {
            return;
        }
        this._isKioskMode = storedIsKioskMode.toLowerCase() === 'true';
    }
    get isKioskMode() {
        return this._isKioskMode;
    }
    activateKioskMode() {
        if (!this.isKioskMode) {
            this._isKioskMode = true;
            localStorage.setItem('isKioskMode', this._isKioskMode.toString());
        }
    }
    openModal(url) {
        let ref = this.modalService.open(_components_kiosk_modal_kiosk_modal_component__WEBPACK_IMPORTED_MODULE_3__["KioskModalComponent"], { centered: false, size: 'xl', windowClass: 'phone-modal' });
        ref.componentInstance.url = url;
    }
};
KioskModeService.ctorParameters = () => [
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbModal"] }
];
KioskModeService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root',
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbModal"]])
], KioskModeService);



/***/ }),

/***/ "./src/app/services/portego.service.ts":
/*!*********************************************!*\
  !*** ./src/app/services/portego.service.ts ***!
  \*********************************************/
/*! exports provided: PortegoService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PortegoService", function() { return PortegoService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_configuration_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/configuration.service */ "./src/configuration.service.ts");
/* harmony import */ var util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! util */ "./node_modules/util/util.js");
/* harmony import */ var util__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(util__WEBPACK_IMPORTED_MODULE_4__);





let PortegoService = class PortegoService {
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this.serviceUrl = config.getPortegoWebserviceUrl();
        this.httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({
                'Content-Type': 'application/x-www-form-urlencoded'
            })
        };
    }
    getNamesOfTheDay() {
        return this.http.get('assets/data/nameDays.json');
    }
    getSloganOfTheWeek() {
        return this.http.get('assets/data/sloganOfTheWeek.json');
    }
    getContacts(idBuilding) {
        const method = 'buildingannouncements/ContactService/GetAllForBuilding/?idBuilding=';
        return this.http.get(this.serviceUrl + method + idBuilding);
    }
    getAnnouncements(idBuilding, keycode) {
        const method = 'buildingannouncements/AnnouncementService/GetAllForBuilding/?';
        const parameter = !Object(util__WEBPACK_IMPORTED_MODULE_4__["isNullOrUndefined"])(keycode) ? 'idBuilding=' + idBuilding + '&keycode=' + keycode : 'idBuilding=' + idBuilding;
        return this.http.get(this.serviceUrl + method + parameter);
    }
    getBuildings(value) {
        const method = 'buildingannouncements/BuildingService/Search?value=';
        return this.http.get(this.serviceUrl + method + value);
    }
    getBuildingAdress(idBuilding) {
        const method = 'buildingannouncements/BuildingService/Get/?idBuilding=';
        return this.http.get(this.serviceUrl + method + idBuilding);
    }
    getAppointments(idBuilding, keycode) {
        const method = 'bat/InfoboardService/GetAppointmentsForBuilding/?';
        const parameter = !Object(util__WEBPACK_IMPORTED_MODULE_4__["isNullOrUndefined"])(keycode) ? 'idBuilding=' + idBuilding + '&keycode=' + keycode : 'idBuilding=' + idBuilding;
        return this.http.get(this.serviceUrl + method + parameter);
    }
    getHouseRules(idBuilding) {
        const method = 'buildingannouncements/GeneralContentService/GetAllForBuilding/';
        return this.http.get(this.serviceUrl + method, {
            params: {
                idBuilding: idBuilding.toString()
            }
        });
    }
    getIdBuildingFromBuildingNumber(buildingNumber) {
        const method = 'buildingannouncements/BuildingService/GetIdBuildingFromBuildingNumber/';
        return this.http.get(this.serviceUrl + method, {
            params: {
                buildingNumber: buildingNumber
            }
        });
    }
    existsBuildingWithId(idBuilding) {
        const method = 'buildingannouncements/BuildingService/Exists/';
        return this.http.get(this.serviceUrl + method, {
            params: {
                idBuilding: idBuilding.toString()
            }
        });
    }
    createSubscription(email, idBuilding, keycode) {
        const method = 'buildingannouncements/SubscriptionService/CreateSubscription/';
        const data = new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpParams"]()
            .set('email', email)
            .set('idBuilding', idBuilding.toString())
            .set('keycode', keycode);
        return this.http.post(this.serviceUrl + method, data, this.httpOptions);
    }
    activateSubscription(subscriptionGuid) {
        const method = 'buildingannouncements/SubscriptionService/ActivateSubscription/';
        const data = new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpParams"]()
            .set('subscriptionGuid', subscriptionGuid);
        return this.http.post(this.serviceUrl + method, data, this.httpOptions);
    }
    deleteSubscription(subscriptionGuid) {
        const method = 'buildingannouncements/SubscriptionService/DeleteSubscription/';
        const data = new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpParams"]()
            .set('subscriptionGuid', subscriptionGuid);
        return this.http.post(this.serviceUrl + method, data, this.httpOptions);
    }
};
PortegoService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] },
    { type: src_configuration_service__WEBPACK_IMPORTED_MODULE_3__["default"] }
];
PortegoService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"], src_configuration_service__WEBPACK_IMPORTED_MODULE_3__["default"]])
], PortegoService);



/***/ }),

/***/ "./src/app/views/building-search/building-search.component.less":
/*!**********************************************************************!*\
  !*** ./src/app/views/building-search/building-search.component.less ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3ZpZXdzL2J1aWxkaW5nLXNlYXJjaC9idWlsZGluZy1zZWFyY2guY29tcG9uZW50Lmxlc3MifQ== */");

/***/ }),

/***/ "./src/app/views/building-search/building-search.component.ts":
/*!********************************************************************!*\
  !*** ./src/app/views/building-search/building-search.component.ts ***!
  \********************************************************************/
/*! exports provided: BuildingSearchComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BuildingSearchComponent", function() { return BuildingSearchComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! util */ "./node_modules/util/util.js");
/* harmony import */ var util__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(util__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/services/portego.service */ "./src/app/services/portego.service.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");






let BuildingSearchComponent = class BuildingSearchComponent {
    constructor(portegoService, router) {
        this.portegoService = portegoService;
        this.router = router;
    }
    ngOnInit() {
        const boardKey = localStorage.getItem('board-key');
        if (!Object(util__WEBPACK_IMPORTED_MODULE_3__["isNullOrUndefined"])(boardKey)) {
            this.navigateToBoard(boardKey);
        }
        else if (src_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].singleBuildingModeBoardKey) {
            this.navigateToBoard(src_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].singleBuildingModeBoardKey);
        }
    }
    onKeyUp(event) {
        if (event.key === 'Backspace' || this.value.length > 2) {
            this.portegoService.getBuildings(this.value).subscribe(data => {
                this.buildings = data;
            });
        }
    }
    boardClick(building) {
        let boardKey;
        boardKey = src_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].useBuildingNumberAsBoardKey === true ? building.number : building.id;
        localStorage['board-key'] = boardKey;
        this.navigateToBoard(boardKey);
    }
    navigateToBoard(boardKey) {
        return this.router.navigate([boardKey]);
    }
};
BuildingSearchComponent.ctorParameters = () => [
    { type: src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_4__["PortegoService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
BuildingSearchComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-building-search',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./building-search.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/views/building-search/building-search.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./building-search.component.less */ "./src/app/views/building-search/building-search.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_4__["PortegoService"], _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"]])
], BuildingSearchComponent);



/***/ }),

/***/ "./src/app/views/home/home.component.less":
/*!************************************************!*\
  !*** ./src/app/views/home/home.component.less ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3ZpZXdzL2hvbWUvaG9tZS5jb21wb25lbnQubGVzcyJ9 */");

/***/ }),

/***/ "./src/app/views/home/home.component.ts":
/*!**********************************************!*\
  !*** ./src/app/views/home/home.component.ts ***!
  \**********************************************/
/*! exports provided: HomeComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HomeComponent", function() { return HomeComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var src_app_helper_datetime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/helper/datetime */ "./src/app/helper/datetime.ts");
/* harmony import */ var src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/app/services/portego.service */ "./src/app/services/portego.service.ts");
/* harmony import */ var src_app_services_anouncement_icon_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! src/app/services/anouncement-icon.service */ "./src/app/services/anouncement-icon.service.ts");
/* harmony import */ var src_app_services_appointment_icon_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! src/app/services/appointment-icon.service */ "./src/app/services/appointment-icon.service.ts");
/* harmony import */ var src_app_models_e_contact_type_enum__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! src/app/models/e-contact-type.enum */ "./src/app/models/e-contact-type.enum.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var src_app_services_kiosk_mode_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! src/app/services/kiosk-mode.service */ "./src/app/services/kiosk-mode.service.ts");














let HomeComponent = class HomeComponent {
    constructor(route, router, portegoService, iconService, appoinmentIconService, carouselConfig, httpClient, kioskModeService) {
        this.route = route;
        this.router = router;
        this.portegoService = portegoService;
        this.iconService = iconService;
        this.appoinmentIconService = appoinmentIconService;
        this.carouselConfig = carouselConfig;
        this.httpClient = httpClient;
        this.kioskModeService = kioskModeService;
        this.dateTimeService = new src_app_helper_datetime__WEBPACK_IMPORTED_MODULE_3__["DateTime"]();
        this.isDemo =  false || src_environments_environment__WEBPACK_IMPORTED_MODULE_8__["environment"].isDemo;
        this.keycode = this.route.snapshot.params.keycode;
        this.currentDay = new src_app_helper_datetime__WEBPACK_IMPORTED_MODULE_3__["DateTime"]().getCurrentDate();
        this.weekday = new Date().toLocaleString('de-AT', { weekday: 'long' });
        if (this.isDemo && 'demo' === this.route.snapshot.routeConfig.path) {
            this.idBuilding = 901;
        }
        else if (src_environments_environment__WEBPACK_IMPORTED_MODULE_8__["environment"].useBuildingNumberAsBoardKey) {
            this.buildingNumber = this.route.snapshot.params.boardKey;
        }
        else {
            this.idBuilding = this.route.snapshot.params.boardKey;
        }
        this.carouselConfig.interval = 12000;
        this.carouselConfig.wrap = true;
        this.carouselConfig.pauseOnHover = true;
        this.carouselConfig.showNavigationArrows = false;
        this.yourDaySlideInfo = {
            currentSlideNumber: 1,
            totalSlideCount: 2
        };
    }
    ngOnInit() {
        this.getCustomerData();
        this.getIdBuilding().subscribe((idBuilding) => {
            this.idBuilding = idBuilding;
            this.getHouseRules();
            this.getFireSafetyRules();
            this.getAnnouncements();
            this.getContacts();
            this.getAppointments();
        }, (error) => {
            console.log(error);
            this.navigateToSearch();
        });
        this.isKioskMode = this.kioskModeService.isKioskMode;
    }
    getIdBuilding() {
        if (src_environments_environment__WEBPACK_IMPORTED_MODULE_8__["environment"].useBuildingNumberAsBoardKey) {
            return this.portegoService.getIdBuildingFromBuildingNumber(this.buildingNumber);
        }
        return this.portegoService.existsBuildingWithId(this.idBuilding).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_11__["switchMap"])((exists) => {
            if (exists) {
                return Object(rxjs__WEBPACK_IMPORTED_MODULE_10__["of"])(this.idBuilding);
            }
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_10__["throwError"])('no building with id ' + this.idBuilding + ' found');
        }));
    }
    getHouseRules() {
        this.portegoService.getHouseRules(this.idBuilding).subscribe(data => {
            const generalContent = data;
            const rules = generalContent.filter(p => p.categoryKey === 'HOUSERULES').map(p => p.image);
            this.rules = rules;
            if (rules.length > 1) {
                this.rulesSlideInfo = {
                    currentSlideNumber: 1,
                    totalSlideCount: rules.length,
                };
            }
        });
    }
    getFireSafetyRules() {
        this.portegoService.getHouseRules(this.idBuilding).subscribe(data => {
            const generalContent = data;
            const rules = generalContent.filter(p => p.categoryKey === 'FIRESAFETY').map(p => p.image);
            this.fireSafetyRules = rules;
            if (rules.length > 1) {
                this.fireSafetySlideInfo = {
                    currentSlideNumber: 1,
                    totalSlideCount: rules.length,
                };
            }
        });
    }
    getContacts() {
        this.portegoService.getContacts(this.idBuilding).subscribe(data => {
            const allContacts = data;
            this.contacts = allContacts.filter(p => p.eType === src_app_models_e_contact_type_enum__WEBPACK_IMPORTED_MODULE_7__["EContactType"].Contact);
            this.emergencyContacts = allContacts.filter(p => p.eType === src_app_models_e_contact_type_enum__WEBPACK_IMPORTED_MODULE_7__["EContactType"].EmergencyContact);
            if (this.contacts.length > 1) {
                this.contactsSlideInfo = {
                    currentSlideNumber: 1,
                    totalSlideCount: this.contacts.length
                };
            }
            // Emergency Contacts have a default slide
            if (this.emergencyContacts.length > 0) {
                this.emergencyContactsSlideInfo = {
                    currentSlideNumber: 1,
                    totalSlideCount: this.emergencyContacts.length + 1
                };
            }
        });
    }
    getAnnouncements() {
        this.portegoService.getAnnouncements(this.idBuilding, this.keycode).subscribe(data => {
            const announcements = data;
            for (const a of announcements) {
                if (a.publishedOn != null) {
                    const date = new Date(a.publishedOn);
                    a.publishedOnLabel = this.dateTimeService.getFormattedDate(date);
                    a.backButton = true;
                    a.typeIconUrl = this.iconService.getIconPath(a.type);
                }
            }
            this.announcements = announcements;
            this.hasAnnouncements = this.announcements.length > 0;
            this.hasAnnouncement = this.announcements.length === 1;
            this.shouldRenderAnnouncements = this.announcements.length > 1;
            if (this.hasAnnouncement) {
                this.announcement = this.announcements[0];
                this.announcement.backButton = false;
            }
            if (this.shouldRenderAnnouncements) {
                this.announcementsSlideInfo = {
                    currentSlideNumber: 1,
                    totalSlideCount: this.announcements.length + 1
                };
            }
        });
    }
    getAppointments() {
        this.portegoService.getAppointments(this.idBuilding, this.keycode).subscribe(data => {
            this.appointments = data;
            for (const a of this.appointments) {
                a.backButton = true;
                const currentDate = new Date();
                const today = this.dateTimeService.getFormattedDate(currentDate);
                currentDate.setDate(currentDate.getDate() + 1);
                const tomorrow = this.dateTimeService.getFormattedDate(currentDate);
                a.highlighted = (a.dateLabel === today || a.dateLabel === tomorrow);
                a.typeIconUrl = this.appoinmentIconService.getIconPath(a.appointmentTypeCode);
            }
            this.hasAppointment = this.appointments.length === 1;
            this.hasAppointments = this.appointments.length > 0;
            this.shouldRenderAppointments = this.appointments.length > 1;
            if (this.hasAppointment) {
                this.appointment = this.appointments[0];
                this.appointment.backButton = false;
            }
            if (this.shouldRenderAppointments) {
                this.appointmentsSlideInfo = {
                    currentSlideNumber: 1,
                    totalSlideCount: this.appointments.length + 1
                };
            }
        });
    }
    getCustomerData() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.httpClient.get('/assets/data/customerData.json').subscribe(data => {
                this.customerData = data;
            });
        });
    }
    afterSlide(event, slideInfo) {
        slideInfo.currentSlideNumber = +event.current.substr(event.current.lastIndexOf('-') + 1) + 1;
    }
    carouselSlideToFirst(carousel) {
        carousel.select(carousel.slides.first.id);
    }
    carouselSlideTo(carousel, slideId) {
        carousel.select(slideId);
    }
    downloadFitnessRules(event) {
        if (this.kioskModeService.isKioskMode) {
            this.kioskModeService.openModal(event.target.href);
            return false;
        }
        return true;
    }
    navigateToSearch() {
        localStorage.removeItem('board-key');
        this.router.navigate(['/search']);
    }
};
HomeComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_4__["PortegoService"] },
    { type: src_app_services_anouncement_icon_service__WEBPACK_IMPORTED_MODULE_5__["AnouncementIconService"] },
    { type: src_app_services_appointment_icon_service__WEBPACK_IMPORTED_MODULE_6__["AppoinmentIconService"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_9__["NgbCarouselConfig"] },
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_12__["HttpClient"] },
    { type: src_app_services_kiosk_mode_service__WEBPACK_IMPORTED_MODULE_13__["KioskModeService"] }
];
HomeComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-home',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./home.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/views/home/home.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./home.component.less */ "./src/app/views/home/home.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [_angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"],
        _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"],
        src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_4__["PortegoService"],
        src_app_services_anouncement_icon_service__WEBPACK_IMPORTED_MODULE_5__["AnouncementIconService"],
        src_app_services_appointment_icon_service__WEBPACK_IMPORTED_MODULE_6__["AppoinmentIconService"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_9__["NgbCarouselConfig"],
        _angular_common_http__WEBPACK_IMPORTED_MODULE_12__["HttpClient"],
        src_app_services_kiosk_mode_service__WEBPACK_IMPORTED_MODULE_13__["KioskModeService"]])
], HomeComponent);



/***/ }),

/***/ "./src/app/views/imprint/imprint.component.less":
/*!******************************************************!*\
  !*** ./src/app/views/imprint/imprint.component.less ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3ZpZXdzL2ltcHJpbnQvaW1wcmludC5jb21wb25lbnQubGVzcyJ9 */");

/***/ }),

/***/ "./src/app/views/imprint/imprint.component.ts":
/*!****************************************************!*\
  !*** ./src/app/views/imprint/imprint.component.ts ***!
  \****************************************************/
/*! exports provided: ImprintComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImprintComponent", function() { return ImprintComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ImprintComponent = class ImprintComponent {
    constructor() { }
    ngOnInit() {
        this.location = location;
    }
};
ImprintComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-imprint',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./imprint.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/views/imprint/imprint.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./imprint.component.less */ "./src/app/views/imprint/imprint.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], ImprintComponent);



/***/ }),

/***/ "./src/app/views/kiosk-mode/kiosk-mode.component.less":
/*!************************************************************!*\
  !*** ./src/app/views/kiosk-mode/kiosk-mode.component.less ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3ZpZXdzL2tpb3NrLW1vZGUva2lvc2stbW9kZS5jb21wb25lbnQubGVzcyJ9 */");

/***/ }),

/***/ "./src/app/views/kiosk-mode/kiosk-mode.component.ts":
/*!**********************************************************!*\
  !*** ./src/app/views/kiosk-mode/kiosk-mode.component.ts ***!
  \**********************************************************/
/*! exports provided: KioskModeComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KioskModeComponent", function() { return KioskModeComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var src_app_services_kiosk_mode_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/services/kiosk-mode.service */ "./src/app/services/kiosk-mode.service.ts");




let KioskModeComponent = class KioskModeComponent {
    constructor(kioskModeService, router) {
        this.kioskModeService = kioskModeService;
        this.router = router;
    }
    ngOnInit() {
        this.kioskModeService.activateKioskMode();
        this.router.navigateByUrl('');
    }
};
KioskModeComponent.ctorParameters = () => [
    { type: src_app_services_kiosk_mode_service__WEBPACK_IMPORTED_MODULE_3__["KioskModeService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
KioskModeComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-kiosk-mode',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./kiosk-mode.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/views/kiosk-mode/kiosk-mode.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./kiosk-mode.component.less */ "./src/app/views/kiosk-mode/kiosk-mode.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [src_app_services_kiosk_mode_service__WEBPACK_IMPORTED_MODULE_3__["KioskModeService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"]])
], KioskModeComponent);



/***/ }),

/***/ "./src/app/views/subscription/subscription.component.less":
/*!****************************************************************!*\
  !*** ./src/app/views/subscription/subscription.component.less ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3ZpZXdzL3N1YnNjcmlwdGlvbi9zdWJzY3JpcHRpb24uY29tcG9uZW50Lmxlc3MifQ== */");

/***/ }),

/***/ "./src/app/views/subscription/subscription.component.ts":
/*!**************************************************************!*\
  !*** ./src/app/views/subscription/subscription.component.ts ***!
  \**************************************************************/
/*! exports provided: SubscriptionComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubscriptionComponent", function() { return SubscriptionComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/services/portego.service */ "./src/app/services/portego.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");




let SubscriptionComponent = class SubscriptionComponent {
    constructor(portegoService, route) {
        this.portegoService = portegoService;
        this.route = route;
        this.success = false;
        this.idBuilding = this.route.snapshot.params.idBuilding;
        this.subscriptionGuid = this.route.snapshot.params.subscriptionGuid;
        this.portegoService.getBuildingAdress(this.idBuilding).subscribe(data => {
            this.buildingLabel = data.label;
        });
        this.isSubscribe = this.route.snapshot.routeConfig.path.startsWith('subscribe/');
    }
    ngOnInit() {
        if (this.isSubscribe) {
            this.portegoService.activateSubscription(this.subscriptionGuid).subscribe(() => this.success = true, () => this.success = false);
        }
        else {
            this.portegoService.deleteSubscription(this.subscriptionGuid).subscribe(() => this.success = true, () => this.success = false);
        }
    }
};
SubscriptionComponent.ctorParameters = () => [
    { type: src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_2__["PortegoService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["ActivatedRoute"] }
];
SubscriptionComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-subscription',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./subscription.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/views/subscription/subscription.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./subscription.component.less */ "./src/app/views/subscription/subscription.component.less")).default]
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [src_app_services_portego_service__WEBPACK_IMPORTED_MODULE_2__["PortegoService"], _angular_router__WEBPACK_IMPORTED_MODULE_3__["ActivatedRoute"]])
], SubscriptionComponent);



/***/ }),

/***/ "./src/configuration.service.ts":
/*!**************************************!*\
  !*** ./src/configuration.service.ts ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");



let ConfigurationService = class ConfigurationService {
    constructor() { }
    getPortegoWebserviceUrl() {
        if (_environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].portegoWebserviceUrl == null) {
            throw new Error('PortegoWebserviceUrl is not defined');
        }
        return _environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].portegoWebserviceUrl;
    }
    getOpenWeatherMapApiKey() {
        if (_environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].openWeatherMapApiKey == null) {
            throw new Error('OpenWeatherMapApiKey is not defined');
        }
        return _environments_environment__WEBPACK_IMPORTED_MODULE_2__["environment"].openWeatherMapApiKey;
    }
};
ConfigurationService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    }),
    tslib__WEBPACK_IMPORTED_MODULE_0__["__metadata"]("design:paramtypes", [])
], ConfigurationService);
/* harmony default export */ __webpack_exports__["default"] = (ConfigurationService);


/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const environment = {
    production: true,
    isDemo: false,
    useBuildingNumberAsBoardKey: true,
    singleBuildingModeBoardKey: null,
    portegoWebserviceUrl: 'https://portego.schwarzesbrett.bfm-facility.at/api/',
    openWeatherMapApiKey: 'e7f0fd2faef4b9228cc30e108da1762f',
    htmlDocumentTitle: 'Schwarzes Brett',
    hideCompanyLogo: false,
    links: [
        [
            {
                url: 'https://bodner-immobilien.at',
                iconPath: 'assets/images/link_logo.svg',
                title: 'www.bodner-immobilien.at'
            },
        ]
    ]
};


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");





if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! C:\_dev\Source\Repos\SchwarzesBrett.InfoboardsWeb\infoboardsweb-app\src\main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map